(function() {
  angular.module('homemademessClient', ['ngAria', 'ngResource', 'ngCookies', 'ui.router', 'ngMaterial', 'ngTagsInput', 'ngLodash', 'debounce', 'oc.lazyLoad', 'btford.socket-io', 'swipe']);

}).call(this);


(function() {
  'use strict';
  var SlideInfoCtrl;

  SlideInfoCtrl = (function() {
    function SlideInfoCtrl(Slides, $scope, $cookies) {
      this.Slides = Slides;
      this.$scope = $scope;
      this.$cookies = $cookies;
      this.showSlideInfo = Boolean(this.$cookies.get('showSlideInfo'));
    }

    SlideInfoCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      this.Slides.get({
        id: this.slide._id
      }, function(slide) {
        ctrl.slide.exif = slide.exif;
        return ctrl.slide.tags = slide.tags;
      });
      return this.$scope.$on('slide.toggle.info', function() {
        return ctrl.toggle();
      });
    };

    SlideInfoCtrl.prototype.toggle = function() {
      var ctrl;
      ctrl = this;
      switch (this.showSlideInfo) {
        case true:
          ctrl.$cookies.remove('showSlideInfo');
          return ctrl.showSlideInfo = false;
        default:
          ctrl.$cookies.put('showSlideInfo', true);
          return ctrl.showSlideInfo = true;
      }
    };

    return SlideInfoCtrl;

  })();

  angular.module('homemademessClient').component('slideInfo', {
    bindings: {
      slide: '<'
    },
    templateUrl: 'app/components/slideshow/slide/slideInfo.html',
    controller: ['Slides', '$scope', '$cookies', SlideInfoCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SlideActionCtrl;

  SlideActionCtrl = (function() {
    function SlideActionCtrl(Slides, $scope, $mdDialog, broadcastService, Download, Private, Public, menuService) {
      var ctrl;
      this.Slides = Slides;
      this.$scope = $scope;
      this.$mdDialog = $mdDialog;
      this.broadcastService = broadcastService;
      this.Download = Download;
      this.Private = Private;
      this.Public = Public;
      this.menuService = menuService;
      ctrl = this;
      this.menuConfig = {
        registerID: 'SlideActionPrivate',
        filterMenu: function(item, itemArray, registerID) {
          if (item.action === 'slide.private' && registerID === 'SlideActionPrivate' && ctrl.slide["private"]) {
            return [];
          }
          if (item.action === 'slide.public' && registerID === 'SlideActionPrivate' && !ctrl.slide["private"]) {
            return [];
          }
          return itemArray;
        },
        menuSlideAction: [
          {
            label: 'Make Image Private',
            src: 'lock',
            action: 'slide.private',
            states: ['home', 'tagged'],
            roles: ['admin'],
            direction: 'top'
          }, {
            label: 'Make Image Public',
            src: 'lock_open',
            action: 'slide.public',
            states: ['home', 'tagged'],
            roles: ['admin'],
            direction: 'top'
          }
        ]
      };
    }

    SlideActionCtrl.prototype.removeTag = function(tag) {
      return this.Slides.update({
        id: this.image._id
      }, {
        tags: this.image.tags.map(function(t) {
          return t._id;
        })
      });
    };

    SlideActionCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      this.menuService.registerMenu(this.menuConfig);
      this.$scope.$on('slide.download', function(e) {
        var download;
        download = ctrl.slide._id + '/' + ctrl.slide.filename;
        return ctrl.Download.one({
          id: download
        }, function(data) {
          var a;
          a = document.createElement('a');
          a.href = data.response;
          a.download = ctrl.slide.filename;
          return a.click();
        });
      });
      this.$scope.$on('slide.delete', function(e) {
        var confirm;
        confirm = ctrl.$mdDialog.confirm().title('Do you really want to delete this image?').ok('Yes please').cancel('Oops - no dont!').multiple(true);
        return ctrl.$mdDialog.show(confirm).then(function() {
          return ctrl.Slides["delete"]({
            id: ctrl.slide._id
          }, function(r) {
            return ctrl.broadcastService.send('slideshow.exit');
          });
        }, function() {
          return true;
        });
      });
      this.$scope.$on('slide.private', function(e) {
        var id;
        id = ctrl.slide._id + '/' + ctrl.slide.filename;
        return ctrl.Private.one({
          id: id
        }, function(slide) {
          return ctrl.onUpdate({
            prop: 'private',
            value: slide["private"]
          });
        });
      });
      return this.$scope.$on('slide.public', function(e) {
        var id;
        id = ctrl.slide._id + '/' + ctrl.slide.filename;
        return ctrl.Public.one({
          id: id
        }, function(slide) {
          return ctrl.onUpdate({
            prop: 'private',
            value: slide["private"]
          });
        });
      });
    };

    return SlideActionCtrl;

  })();

  angular.module('homemademessClient').component('slideAction', {
    bindings: {
      slide: '<',
      onUpdate: '&'
    },
    controller: ['Slides', '$scope', '$mdDialog', 'broadcastService', 'Download', 'Private', 'Public', 'menuService', SlideActionCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SlideCtrl;

  SlideCtrl = (function() {
    function SlideCtrl($stateParams, $element, $mdMedia) {
      this.$stateParams = $stateParams;
      this.$mdMedia = $mdMedia;
      $element.addClass('close-slide');
    }

    SlideCtrl.prototype.$onInit = function() {
      var ctrl, img, index, size;
      ctrl = this;
      index = this.slideshow.view.map.indexOf(this.$stateParams.slide);
      this.slide = this.slideshow.view.images[index];
      this.type = this.slide.mimeType.split('/')[0];
      size = this.getDerivative();
      img = this.slide.derivative[size];
      if (img.height > img.width) {
        this.layclss = 'vert';
      } else {
        this.layclss = 'horz';
      }
      this.src = img.uri;
      return this.label = this.slide.filename;
    };

    SlideCtrl.prototype.getDerivative = function() {
      switch (this.type) {
        case 'image':
          switch (false) {
            case !this.$mdMedia('xs'):
              return 1;
            case !this.$mdMedia('sm'):
              return 1;
            default:
              return 2;
          }
          break;
        case 'video':
          return 1;
      }
    };

    SlideCtrl.prototype.updateSlide = function(prop, value) {
      var slideCopy;
      slideCopy = angular.copy(this.slide);
      slideCopy[prop] = value;
      return this.slide = slideCopy;
    };

    return SlideCtrl;

  })();

  angular.module('homemademessClient').component('slide', {
    require: {
      slideshow: '^^'
    },
    templateUrl: 'app/components/slideshow/slide/slide.html',
    controller: ['$stateParams', '$element', '$mdMedia', SlideCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var UploadDateCtrl;

  UploadDateCtrl = (function() {
    function UploadDateCtrl(filterService) {
      this.filterService = filterService;
      this.dates = [];
    }

    UploadDateCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      return this.filterService.getUploadDates().then(function(dates) {
        return angular.forEach(dates, function(timestamp, i) {
          return ctrl.dates.push({
            date: moment(timestamp._id).format('MM-DD-YYYY')
          });
        });
      });
    };

    UploadDateCtrl.prototype.addDate = function(date) {
      var filter;
      filter = angular.copy(this.filter);
      filter.date.up = date;
      return this.onUpdate({
        filter: filter
      });
    };

    return UploadDateCtrl;

  })();

  angular.module('homemademessClient').component('uploadDate', {
    bindings: {
      filter: '<',
      onUpdate: '&'
    },
    templateUrl: 'app/components/filter/uploadDate/uploadDate.html',
    controller: ['filterService', UploadDateCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var DateRangeCtrl;

  DateRangeCtrl = (function() {
    function DateRangeCtrl(filterService) {
      this.filterService = filterService;
      this.maxDate = moment().valueOf();
      this.minDate = 0;
      this.from;
      this.to;
      this.maxFrom;
      this.minTo;
    }

    DateRangeCtrl.prototype.$onInit = function() {
      var ctrl, ref, ref1, ref2, ref3;
      ctrl = this;
      this.from = (((ref = this.filter) != null ? (ref1 = ref.date) != null ? ref1.from : void 0 : void 0) != null) && this.filter.date.from !== 0 ? new Date(moment(this.filter.date.from).toISOString()) : null;
      this.to = (((ref2 = this.filter) != null ? (ref3 = ref2.date) != null ? ref3.to : void 0 : void 0) != null) && this.filter.date.to !== 0 ? new Date(moment(this.filter.date.to).toISOString()) : null;
      this.maxFrom = this.maxDate;
      this.minTo = this.minDate;
      return this.filterService.getDateBoundaries().then(function(dates) {
        ctrl.minDate = new Date(moment(dates.from).toISOString());
        ctrl.maxDate = new Date(moment(dates.to).toISOString());
        if (ctrl.from === null) {
          ctrl.from = ctrl.minDate;
        }
        if (ctrl.to === null) {
          ctrl.to = ctrl.maxDate;
        }
        ctrl.maxFrom = ctrl.to;
        return ctrl.minTo = ctrl.from;
      });
    };

    DateRangeCtrl.prototype.$onChanges = function() {
      var ref, ref1, ref2, ref3;
      this.from = (((ref = this.filter) != null ? (ref1 = ref.date) != null ? ref1.from : void 0 : void 0) != null) && this.filter.date.from !== 0 ? new Date(moment(this.filter.date.from).toISOString()) : this.minDate;
      return this.to = (((ref2 = this.filter) != null ? (ref3 = ref2.date) != null ? ref3.to : void 0 : void 0) != null) && this.filter.date.to !== 0 ? new Date(moment(this.filter.date.to).toISOString()) : this.maxDate;
    };

    DateRangeCtrl.prototype.setDate = function() {
      var ctrl, filter, from, to;
      ctrl = this;
      if (ctrl.from !== ctrl.minDate) {
        from = moment(ctrl.from).valueOf();
        if (from !== ctrl.filter.date.from) {
          filter = angular.copy(ctrl.filter);
          filter.date.from = from;
          ctrl.onUpdate({
            filter: filter
          });
          ctrl.minTo = ctrl.from;
        }
      }
      if (ctrl.to !== ctrl.maxDate) {
        to = moment(ctrl.to).valueOf();
        if (to !== ctrl.filter.date.to) {
          filter = angular.copy(ctrl.filter);
          filter.date.to = to;
          ctrl.onUpdate({
            filter: filter
          });
          return ctrl.maxFrom = ctrl.to;
        }
      }
    };

    return DateRangeCtrl;

  })();

  angular.module('homemademessClient').component('dateRange', {
    bindings: {
      filter: '<',
      onUpdate: '&'
    },
    templateUrl: 'app/components/filter/dateRange/dateRange.html',
    controller: ['filterService', DateRangeCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var tagDialogService;

  tagDialogService = function($resource, apiUrl) {
    var api;
    api = $resource(apiUrl + '/select/tags/:id');
    return {
      get: function() {
        return api.get(function(t) {
          return t;
        }, function(e) {
          return console.log(e);
        }).$promise;
      },
      add: function(tags) {
        return api.save(tags, function(t) {
          return t;
        }, function(e) {
          return console.log(e);
        }).$promise;
      },
      remove: function(tagid) {
        return api["delete"]({
          id: tagid
        }, function(t) {
          return t;
        }, function(e) {
          return console.log(e);
        }).$promise;
      }
    };
  };

  angular.module('homemademessClient').factory('tagDialogService', ['$resource', 'apiUrl', tagDialogService]);

}).call(this);


(function() {
  'use strict';
  var TagDialogCtrl;

  TagDialogCtrl = (function() {
    function TagDialogCtrl(Auto, Tags, tagDialogService, selectService, $mdDialog) {
      var ctrl;
      ctrl = this;
      this.Auto = Auto;
      this.Tags = Tags;
      this.tagDialogService = tagDialogService;
      this.selectService = selectService;
      this.$mdDialog = $mdDialog;
      this.selectedTags = [];
      this.searchText;
      this.selectedItem;
      this.tagDialogService.get().then(function(tags) {
        return ctrl.tagsInView = tags.objects;
      });
    }

    TagDialogCtrl.prototype.findTags = function(value) {
      return this.Auto.query({
        q: value
      });
    };

    TagDialogCtrl.prototype.prepareTag = function(tag) {
      if (angular.isObject(tag && tag.hasOwnProperty('text'))) {
        return tag;
      } else if (angular.isString(tag)) {
        return {
          text: tag,
          _images: []
        };
      }
    };

    TagDialogCtrl.prototype.clearSelectedTags = function() {
      return this.selectedTags = [];
    };

    TagDialogCtrl.prototype.getSelectedTagIds = function() {
      return this.selectedTags.map(function(tag) {
        return tag._id;
      });
    };

    TagDialogCtrl.prototype.remove = function(tag) {
      return this.tagDialogService.remove(tag._id);
    };

    TagDialogCtrl.prototype.add = function() {
      var ctrl, stop, tagids;
      ctrl = this;
      stop = false;
      angular.forEach(this.selectedTags, function(tag, i) {
        if (tag._id == null) {
          stop = true;
          return ctrl.Tags.save(tag, function(t) {
            ctrl.selectedTags[i] = t;
            return ctrl.add();
          });
        }
      });
      if (stop) {
        return false;
      }
      if (this.selectedTags.length > 0) {
        tagids = this.getSelectedTagIds();
        return this.tagDialogService.add(tagids).then(function(r) {
          return ctrl.tagDialogService.get().then(function(tags) {
            ctrl.tagsInView = tags.objects;
            return ctrl.clearSelectedTags();
          });
        });
      }
    };

    return TagDialogCtrl;

  })();

  angular.module('homemademessClient').controller('TagDialogCtrl', ['Auto', 'Tags', 'tagDialogService', 'selectService', '$mdDialog', TagDialogCtrl]);

}).call(this);


(function() {
  'use strict';
  var TagCtrl;

  TagCtrl = (function() {
    function TagCtrl(menuService) {
      this.menuService = menuService;
      this.menuConfig = {
        registerID: 'TagCtrl',
        menuSelectAction: [
          {
            label: 'Tag/Untag Selected',
            src: 'add_circle',
            action: 'selected.tag',
            states: ['home'],
            roles: ['admin'],
            direction: 'top'
          }
        ]
      };
    }

    TagCtrl.prototype.$onInit = function() {
      return this.menuService.registerMenu(this.menuConfig);
    };

    TagCtrl.prototype.$onDestroy = function() {
      return this.menuService.removeMenu(this.menuConfig.registerID);
    };

    return TagCtrl;

  })();

  angular.module('homemademessClient').component('tagControl', {
    controller: ['menuService', TagCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SelectActionsCtrl;

  SelectActionsCtrl = (function() {
    function SelectActionsCtrl($scope, $mdDialog, selectService, Download, Private, Public) {
      this.$scope = $scope;
      this.$mdDialog = $mdDialog;
      this.selectService = selectService;
      this.Download = Download;
      this.Private = Private;
      this.Public = Public;
    }

    SelectActionsCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      this.$scope.$on('selected.tag', function(e) {
        return ctrl.$mdDialog.show({
          templateUrl: 'app/components/admin/tag/tagDialog.html',
          controller: 'TagDialogCtrl',
          controllerAs: 'ctrl'
        });
      });
      this.$scope.$on('selected.delete', function(e) {
        return ctrl.$mdDialog.show({
          templateUrl: 'app/components/admin/delete/deleteDialog.html',
          controller: 'DeleteDialogCtrl',
          controllerAs: 'ctrl',
          locals: {
            images: ctrl.selectService.getSelected()
          },
          bindToController: true
        });
      });
      this.$scope.$on('selected.download', function(e) {
        var dl, selected;
        selected = ctrl.selectService.getSelected();
        dl = function(url) {
          var ifrm;
          ifrm = document.createElement('iframe');
          ifrm.setAttribute('style', 'display:none;');
          ifrm.setAttribute('src', url);
          ifrm.style.width = '0px';
          ifrm.style.height = '0px';
          return document.body.appendChild(ifrm);
        };
        return ctrl.Download.many({
          download: selected
        }, function(data) {
          var links;
          links = data.response.split('\r');
          return links.forEach(function(l, i) {
            if (l.length) {
              return dl(l);
            }
          });
        });
      });
      this.$scope.$on('selected.private', function(e) {
        var selected;
        selected = ctrl.selectService.getSelected();
        return ctrl.Private.many({
          "private": selected
        }, function(data) {});
      });
      this.$scope.$on('selected.public', function(e) {
        var selected;
        selected = ctrl.selectService.getSelected();
        return ctrl.Public.many({
          "public": selected
        }, function(data) {});
      });
      return this.$scope.$on('image.delete.complete', function(e, id) {
        var i;
        i = ctrl.selectService.selected.indexOf(id);
        if (i >= 0) {
          return ctrl.selectService.selected.splice(i, 1);
        }
      });
    };

    return SelectActionsCtrl;

  })();

  angular.module('homemademessClient').component('selectActions', {
    controller: ['$scope', '$mdDialog', 'selectService', 'Download', 'Private', 'Public', SelectActionsCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SelectCtrl;

  SelectCtrl = (function() {
    function SelectCtrl(selectService, menuService, $scope) {
      var ctrl;
      this.menuService = menuService;
      this.$scope = $scope;
      this.selectService = selectService;
      ctrl = this;
      this.menuConfig = {
        registerID: 'select',
        filterTrigger: function(currentTrigger) {
          if (selectService.isEmpty()) {
            return currentTrigger;
          } else {
            return "offline_pin";
          }
        },
        filterMenu: function(item, itemArray, registerID) {
          if (item.action === 'select.all' && registerID === 'select' && !selectService.isEmpty()) {
            return [];
          }
          return itemArray;
        },
        menuMiddle: [
          {
            label: 'Select All (on all pages)',
            src: 'done_all',
            action: 'select.all',
            states: ['home', 'tagged'],
            roles: ['admin', 'download']
          }
        ],
        menuSelectAction: [
          {
            label: 'Deselect All',
            src: 'select_all',
            action: 'menu.select.none',
            states: ['home', 'tagged'],
            roles: ['admin', 'download'],
            direction: 'top'
          }, {
            label: 'Select All (on all pages)',
            src: 'done_all',
            action: 'menu.select.all',
            states: ['home', 'tagged'],
            roles: ['admin', 'download'],
            direction: 'top'
          }
        ]
      };
    }

    SelectCtrl.prototype.toggleSelect = function(id, value) {
      var i;
      i = this.view.map.indexOf(id);
      if (i > -1) {
        return this.view.images[i].selected = value;
      }
    };

    SelectCtrl.prototype.toggleSelectAll = function(value) {
      var ctrl;
      ctrl = this;
      return angular.forEach(this.view.images, function(img, i) {
        return ctrl.view.images[i].selected = value;
      });
    };

    SelectCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      ctrl.menuService.registerMenu(ctrl.menuConfig);
      this.selectService.init().then(function(s) {
        return angular.forEach(ctrl.view.images, function(img, i) {
          if (ctrl.selectService.selected.indexOf(img._id) > -1) {
            return ctrl.view.images[i].selected = true;
          }
        });
      });
      this.$scope.$on('slide.select', function(e, slide) {
        return ctrl.selectService.toggle(slide._id);
      });
      this.$scope.$on('menu.select.none', function(e) {
        return ctrl.selectService.none();
      });
      this.$scope.$on('menu.select.all', function(e) {
        return ctrl.selectService.all();
      });
      this.$scope.$on('select.on', function(e, id) {
        return ctrl.toggleSelect(id, true);
      });
      this.$scope.$on('select.off', function(e, id) {
        return ctrl.toggleSelect(id, false);
      });
      this.$scope.$on('select.all', function() {
        return ctrl.toggleSelectAll(true);
      });
      this.$scope.$on('select.none', function() {
        return ctrl.toggleSelectAll(false);
      });
      this.$scope.$on('auth.logout', function() {
        return ctrl.toggleSelectAll(false);
      });
      return this.$scope.$on('auth.logout', function() {
        return ctrl.toggleSelectAll(false);
      });
    };

    SelectCtrl.prototype.$onDestroy = function() {
      return this.menuService.removeMenu(this.menuConfig.registerID);
    };

    return SelectCtrl;

  })();

  angular.module('homemademessClient').component('selectControl', {
    bindings: {
      view: '<'
    },
    templateUrl: 'app/components/admin/select/select.html',
    controller: ['selectService', 'menuService', '$scope', 'Auth', SelectCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SelectDomCtrl;

  SelectDomCtrl = (function() {
    function SelectDomCtrl() {}

    SelectDomCtrl.prototype.$onInit = function() {
      return angular.element(document.body).addClass('has-selected');
    };

    SelectDomCtrl.prototype.$onDestroy = function() {
      return angular.element(document.body).removeClass('has-selected');
    };

    return SelectDomCtrl;

  })();

  angular.module('homemademessClient').component('selectDomControl', {
    controller: [SelectDomCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var PrivateCtrl;

  PrivateCtrl = (function() {
    function PrivateCtrl(menuService) {
      this.menuService = menuService;
      this.menuConfig = {
        registerID: 'PrivateCtrl',
        menuSelectAction: [
          {
            label: 'Make Selected Private',
            src: 'lock',
            action: 'selected.private',
            states: ['home', 'tagged'],
            roles: ['admin'],
            direction: 'top'
          }, {
            label: 'Make Selected Public',
            src: 'lock_open',
            action: 'selected.public',
            states: ['home', 'tagged'],
            roles: ['admin'],
            direction: 'top'
          }
        ]
      };
    }

    PrivateCtrl.prototype.$onInit = function() {
      return this.menuService.registerMenu(this.menuConfig);
    };

    return PrivateCtrl;

  })();

  angular.module('homemademessClient').component('privateControl', {
    controller: ['menuService', PrivateCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var EditCtrl;

  EditCtrl = (function() {
    function EditCtrl(menuService, $scope, $mdDialog) {
      this.menuService = menuService;
      this.$scope = $scope;
      this.$mdDialog = $mdDialog;
      this.menuConfig = {
        registerID: 'EditCtrl',
        menuExtra: [
          {
            label: 'Edit Selected',
            src: 'edit',
            action: 'selected.edit',
            states: ['home'],
            roles: ['admin']
          }
        ]
      };
    }

    EditCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      this.menuService.registerMenu(this.menuConfig);
      return this.$scope.$on('menu.selected.edit', function(e) {
        return ctrl.$mdDialog.show({
          clickOutsideToClose: true,
          templateUrl: 'app/components/admin/edit/editDialog.html',
          controller: 'EditDialogCtrl',
          controllerAs: 'ctrl',
          locals: {
            selectedImages: ctrl.selectService.selected
          },
          bindToController: true
        });
      });
    };

    EditCtrl.prototype.$onDestroy = function() {
      return this.menuService.removeMenu(this.menuConfig.registerID);
    };

    return EditCtrl;

  })();

  angular.module('homemademessClient').component('editControl', {
    controller: ['menuService', '$scope', '$mdDialog', EditCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var DZCtrl;

  DZCtrl = (function() {
    function DZCtrl(dropzoneService, broadcastService, queueService, $scope) {
      this.dropzoneService = dropzoneService;
      this.broadcastService = broadcastService;
      this.queueService = queueService;
      this.$scope = $scope;
      this.processing = [];
      this.rejected = [];
      this.queued = [];
      this.uploading = [];
      this.total = 0;
      this.showpreviews = true;
      this.selectoncomplete = false;
      this.inprocess = false;
    }

    DZCtrl.prototype.$onInit = function() {
      var ctrl, ref;
      ctrl = this;
      if (((ref = this.tag) != null ? ref[0] : void 0) != null) {
        this.dropzoneService.setHeaders({
          'HMM-Tag': ctrl.tag[0]._id
        });
      }
      this.dropzoneService.toggle('init');
      this.queueService.get().then(function(q) {
        return console.log('q', q);
      });
      this.$scope.$on('dropzone.success', function(e, args) {
        return angular.element(args.file.previewElement).attr('id', 'dz-' + args.res.Key);
      });
      this.$scope.$on('dropzone.update', function(e, args) {
        angular.forEach(args, function(arg, key) {
          return ctrl[key] = arg;
        });
        return ctrl.$scope.$apply();
      });
      this.$scope.$on('dropzone.progress', function(e, total) {
        return ctrl.total = total;
      });
      this.$scope.$on('image.upload.init', function(e, img) {
        return ctrl.inprocess = img;
      });
      return this.$scope.$on('image.upload.complete', function(e, img) {
        angular.forEach(ctrl.processing, function(file, i) {
          if (file.name === img.filename) {
            return ctrl.dropzoneService.dropzone.removeFile(file);
          }
        });
        if (ctrl.selectoncomplete) {
          return ctrl.broadcastService.send('slide.select', img);
        }
      });
    };

    DZCtrl.prototype.$onDestroy = function() {
      return this.dropzoneService.toggle('destroy');
    };

    return DZCtrl;

  })();

  angular.module('homemademessClient').component('dropzone', {
    templateUrl: 'app/components/admin/dropzone/dropzone.html',
    bindings: {
      tag: '<'
    },
    controller: ['dropzoneService', 'broadcastService', 'queueService', '$scope', DZCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var DownloadCtrl;

  DownloadCtrl = (function() {
    function DownloadCtrl(menuService) {
      this.menuService = menuService;
      this.menuConfig = {
        registerID: 'DownloadCtrl',
        menuSelectAction: [
          {
            label: 'Download Selected Originals',
            src: 'cloud_download',
            action: 'selected.download',
            states: ['home', 'tagged'],
            roles: ['admin', 'download'],
            direction: 'top'
          }
        ],
        menuSlideAction: [
          {
            label: 'Download Original',
            src: 'file_download',
            action: 'slide.download',
            states: ['home', 'tagged'],
            roles: ['admin', 'download'],
            direction: 'top'
          }
        ]
      };
    }

    DownloadCtrl.prototype.$onInit = function() {
      return this.menuService.registerMenu(this.menuConfig);
    };

    return DownloadCtrl;

  })();

  angular.module('homemademessClient').component('downloadControl', {
    controller: ['menuService', DownloadCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var DeleteDialogCtrl;

  DeleteDialogCtrl = (function() {
    function DeleteDialogCtrl(Slides, $mdMedia, $mdDialog, $q) {
      var ctrl;
      this.Slides = Slides;
      this.$mdMedia = $mdMedia;
      this.$mdDialog = $mdDialog;
      this.$q = $q;
      this.count = this.images.length;
      this.cards = (function() {
        switch (false) {
          case !this.$mdMedia('xs'):
            return 2;
          case !this.$mdMedia('sm'):
            return 3;
          case !this.$mdMedia('md'):
            return 4;
          case !this.$mdMedia('lg'):
            return 6;
          case !this.$mdMedia('xl'):
            return 10;
        }
      }).call(this);
      if (this.count > this.cards) {
        this.additional = 'And ' + (this.count - this.cards) + ' more...';
      } else {
        this.additional = '';
      }
      ctrl = this;
      this.Slides.get({
        per: this.cards,
        ids: this.images
      }, function(r) {
        return ctrl.selectedImages = r.images;
      });
    }

    DeleteDialogCtrl.prototype.removeAll = function() {
      var ctrl, promises;
      ctrl = this;
      promises = [];
      this.images.forEach(function(img, i) {
        return promises.push(ctrl.Slides["delete"]({
          id: img
        }).$promise);
      });
      return this.$q.all(promises).then(function() {
        return ctrl.$mdDialog.hide();
      });
    };

    return DeleteDialogCtrl;

  })();

  angular.module('homemademessClient').controller('DeleteDialogCtrl', ['Slides', '$mdMedia', '$mdDialog', '$q', DeleteDialogCtrl]);

}).call(this);


(function() {
  'use strict';
  var DeleteCtrl;

  DeleteCtrl = (function() {
    function DeleteCtrl(menuService) {
      this.menuService = menuService;
      this.menuConfig = {
        registerID: 'DeleteCtrl',
        menuSelectAction: [
          {
            label: 'Delete Selected',
            src: 'delete',
            action: 'selected.delete',
            states: ['home', 'tagged'],
            roles: ['admin'],
            direction: 'top'
          }
        ],
        menuSlideAction: [
          {
            label: 'Delete Image',
            src: 'delete',
            action: 'slide.delete',
            states: ['home', 'tagged'],
            roles: ['admin'],
            direction: 'top'
          }
        ]
      };
    }

    DeleteCtrl.prototype.$onInit = function() {
      return this.menuService.registerMenu(this.menuConfig);
    };

    return DeleteCtrl;

  })();

  angular.module('homemademessClient').component('deleteControl', {
    controller: ['menuService', DeleteCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var TouchCtrl;

  TouchCtrl = (function() {
    function TouchCtrl($cookies, $window, menuService, $scope) {
      this.$cookies = $cookies;
      this.$window = $window;
      this.menuService = menuService;
      this.$scope = $scope;
      this.menuConfig = {
        registerID: 'TouchCtrl',
        menuMiddle: [
          {
            label: 'Upload',
            src: 'cloud_upload',
            action: 'dz-click',
            states: ['home'],
            roles: ['admin']
          }
        ]
      };
    }

    TouchCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      this.touch = this.$cookies.get('touch');
      if (this.touch != null) {
        ctrl.firstTouch();
      } else {
        this.$window.addEventListener('touchstart', function() {
          return ctrl.firstTouch();
        });
      }
      return this.$scope.$on('menu.dz-click', function() {
        return document.querySelector('.dz-hidden-input').click();
      });
    };

    TouchCtrl.prototype.$onDestroy = function() {
      this.$window.removeEventListener('touchstart', this.firstTouch, false);
      return this.menuService.removeMenu(this.menuConfig.registerID);
    };

    TouchCtrl.prototype.firstTouch = function() {
      angular.element(document.body).addClass('touch');
      this.$cookies.put('touch', 1);
      this.$window.removeEventListener('touchstart', this.firstTouch, false);
      return this.menuService.registerMenu(this.menuConfig);
    };

    return TouchCtrl;

  })();

  angular.module('homemademessClient').component('touch', {
    controller: ['$cookies', '$window', 'menuService', '$scope', TouchCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SocketCtrl;

  SocketCtrl = (function() {
    function SocketCtrl(socketService, broadcastService, $scope) {
      this.socketService = socketService;
      this.broadcastService = broadcastService;
      this.$scope = $scope;
    }

    SocketCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      return this.socketService.then(function(s) {
        s.socket.on('image:delete:begin', function(id) {
          return ctrl.broadcastService.send('image.delete.begin', id);
        });
        s.socket.on('image:delete:complete', function(id) {
          return ctrl.broadcastService.send('image.delete.complete', id);
        });
        s.socket.on('image:upload:begin', function(img) {
          return ctrl.broadcastService.send('image.upload.begin', img);
        });
        s.socket.on('image:upload:complete', function(img) {
          return ctrl.broadcastService.send('image.upload.complete', img);
        });
        return s.socket.on('image:update:privacy', function(img) {
          console.log('image.update.privacy', img);
          return ctrl.broadcastService.send('image.update.privacy', img);
        });
      });
    };

    return SocketCtrl;

  })();

  angular.module('homemademessClient').component('socket', {
    controller: ['socketService', 'broadcastService', '$scope', SocketCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SlideshowMenuCtrl;

  SlideshowMenuCtrl = (function() {
    function SlideshowMenuCtrl(menuService, $scope) {
      this.menuService = menuService;
      this.$scope = $scope;
      this.bounce = 400;
      this.menuConfig = {
        registerID: 'SlideActionCtrl',
        menuSlideAction: [
          {
            label: 'Image Info',
            src: 'info',
            action: 'slide.toggle.info',
            states: ['home', 'tagged'],
            roles: ['admin'],
            direction: 'top'
          }, {
            label: 'Close Slideshow',
            src: 'close',
            action: 'slideshow.exit',
            states: ['home', 'tagged'],
            roles: ['admin', 'download', 'anon'],
            direction: 'top'
          }
        ]
      };
    }

    SlideshowMenuCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      ctrl.menuService.registerMenu(ctrl.menuConfig);
      return this.$scope.$on('slideshow.exit', function(e) {
        return ctrl.slideshow.showClose();
      });
    };

    return SlideshowMenuCtrl;

  })();

  angular.module('homemademessClient').component('slideshowMenu', {
    require: {
      slideshow: '^^'
    },
    controller: ['menuService', '$scope', SlideshowMenuCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SlideshowCtrl;

  SlideshowCtrl = (function() {
    function SlideshowCtrl($state, $document, debounce, $stateParams, swipe, $window) {
      this.$state = $state;
      this.$document = $document;
      this.debounce = debounce;
      this.stateParams = $stateParams;
      this.window = $window;
      this.bounce = 400;
    }

    SlideshowCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      angular.element(document.querySelector('body')).addClass('slideshow');
      this.$document.off('keyup').on('keyup', this.debounce(function(e) {
        if (ctrl.$state.transition == null) {
          if ([39, 37, 38, 40, 27].indexOf(e.which !== -1)) {
            switch (e.which) {
              case 39:
                return ctrl.showChange('slideright');
              case 37:
                return ctrl.showChange('slideleft');
              case 38:
                return ctrl.showChange('slideup');
              case 40:
                return ctrl.showChange('slidedown');
              case 27:
                return ctrl.showClose();
            }
          }
        }
      }, ctrl.bounce, true));
      return angular.element(document.querySelector('slideshow')).off('click').on('click', this.debounce(function(e) {
        var test;
        test = angular.element(e.target).hasClass('close-slide');
        if (test) {
          return ctrl.showClose();
        }
      }, ctrl.bounce, true));
    };

    SlideshowCtrl.prototype.$onChanges = function(changes) {
      var cpage, ppage;
      if ((changes.view != null) && (changes.view.previousValue.filter != null)) {
        cpage = changes.view.currentValue.filter.pagination.page;
        ppage = changes.view.previousValue.filter.pagination.page;
        if (cpage > ppage) {
          this.window.location.href = this.$state.href(this.$state.current, {
            slide: this.view.images[0]._id
          });
        }
        if (ppage > cpage) {
          return this.window.location.href = this.$state.href(this.$state.current, {
            slide: this.view.images[this.view.images.length - 1]._id
          });
        }
      }
    };

    SlideshowCtrl.prototype.$onDestroy = function() {
      angular.element(document.querySelector('body')).removeClass('slideshow');
      angular.element(document.querySelector('slideshow')).off('click');
      return this.$document.off('keyup');
    };

    SlideshowCtrl.prototype.showChange = function(e, n) {
      var filter, ref, slideNumber;
      if (this.view.images != null) {
        slideNumber = this.view.map.indexOf(this.stateParams.slide);
        if (slideNumber != null) {
          switch (e) {
            case 'slideright':
              n = slideNumber + 1;
              break;
            case 'slideleft':
              n = slideNumber - 1;
              break;
            case 'slideup':
              n = 0;
              break;
            case 'slidedown':
              n = this.view.images.length - 1;
          }
        }
        if (((ref = this.view.images[n]) != null ? ref._id : void 0) != null) {
          this.window.location.href = this.$state.href(this.$state.current, {
            slide: this.view.images[n]._id
          });
        } else if (n < 0 && this.view.filter.pagination.page > 0) {
          filter = angular.copy(this.view.filter);
          filter.pagination.page = filter.pagination.page - 1;
          this.onUpdate({
            filter: filter
          });
        } else if (n > (this.view.filter.pagination.per - 1)) {
          filter = angular.copy(this.view.filter);
          if ((filter.pagination.count / filter.pagination.per) > filter.pagination.page) {
            filter = angular.copy(this.view.filter);
            filter.pagination.page = filter.pagination.page + 1;
            this.onUpdate({
              filter: filter
            });
          }
        }
      }
      return false;
    };

    SlideshowCtrl.prototype.showClose = function(e) {
      return this.window.location.href = this.$state.href('^.^');
    };

    return SlideshowCtrl;

  })();

  angular.module('homemademessClient').component('slideshow', {
    bindings: {
      view: '<',
      user: '<',
      onUpdate: '&'
    },
    templateUrl: 'app/components/slideshow/slideshow.html',
    controller: ['$state', '$document', 'debounce', '$stateParams', 'swipe', '$window', SlideshowCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SlidesCtrl;

  SlidesCtrl = (function() {
    function SlidesCtrl($scope, $state, broadcastService, $mdMedia, selectService) {
      this.$scope = $scope;
      this.$state = $state;
      this.broadcastService = broadcastService;
      this.$mdMedia = $mdMedia;
      this.selectService = selectService;
      this.cols = {
        xs: 12,
        sm: 24,
        md: 36,
        lg: 48,
        gt: 60
      };
      this.derivative = 0;
    }

    SlidesCtrl.prototype.getLink = function(id) {
      return this.$state.href(this.$state.$current.name + '.slideshow.slide', {
        slide: id
      });
    };

    SlidesCtrl.prototype.ratio = function(img) {
      if (img.orientation >= 5 && img.orientation <= 8) {
        return Math.round((img.derivative[0].width / img.derivative[0].height) * 100) / 100;
      } else {
        return Math.round((img.derivative[0].height / img.derivative[0].width) * 100) / 100;
      }
    };

    SlidesCtrl.prototype.aspect = function(img, n) {
      var a, aspect, cols, columns, ctrl, rows;
      ctrl = this;
      a = this.ratio(img);
      columns = (function() {
        switch (false) {
          case !(a < 0.4):
            switch (false) {
              case !ctrl.$mdMedia('xs'):
                ctrl.derivative = 0;
                return ctrl.cols.xs;
              case !ctrl.$mdMedia('sm'):
                ctrl.derivative = 0;
                return ctrl.cols.sm;
              case !ctrl.$mdMedia('md'):
                ctrl.derivative = 0;
                return ctrl.cols.md;
              case !ctrl.$mdMedia('lg'):
                ctrl.derivative = 1;
                return ctrl.cols.lg;
              case !ctrl.$mdMedia('gt-lg'):
                ctrl.derivative = 1;
                return ctrl.cols.gt;
            }
            break;
          case !(a > 1.8):
            ctrl.derivative = 0;
            cols = (1 / a) * 12;
            return Math.ceil(cols / 3) * 3;
          default:
            ctrl.derivative = 0;
            return 12;
        }
      })();
      rows = Math.round(columns * a);
      aspect = [columns, rows];
      return aspect[n];
    };

    SlidesCtrl.prototype.tryLink = function(e, img) {
      if (!this.selectService.isEmpty()) {
        e.preventDefault();
        return this.selectService.toggle(img._id);
      }
    };

    return SlidesCtrl;

  })();

  angular.module('homemademessClient').component('slides', {
    bindings: {
      view: '<',
      user: '<'
    },
    templateUrl: 'app/components/slides/slides.html',
    controller: ['$scope', '$state', 'broadcastService', '$mdMedia', 'selectService', SlidesCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var SearchbarCtrl;

  SearchbarCtrl = (function() {
    function SearchbarCtrl($resource, Auto) {
      this.Auto = Auto;
    }

    SearchbarCtrl.prototype.findTags = function(value) {
      return this.Auto.query({
        q: value,
        s: 0
      }).$promise;
    };

    SearchbarCtrl.prototype.updateTags = function(tag) {
      var filter, tags;
      tags = [];
      filter = angular.copy(this.filter);
      angular.forEach(this.filter.tag.tags, function(t, i) {
        return tags.push(t.text);
      });
      filter.tag.tagtext = tags;
      return this.onUpdate({
        filter: filter
      });
    };

    return SearchbarCtrl;

  })();

  angular.module('homemademessClient').component('searchbar', {
    controller: ['$resource', 'Auto', SearchbarCtrl],
    bindings: {
      filter: '<',
      onUpdate: '&'
    },
    templateUrl: 'app/components/searchbar/searchbar.html'
  });

}).call(this);


(function() {
  'use strict';
  var PagerCtrl;

  PagerCtrl = (function() {
    function PagerCtrl() {
      this.previous = false;
      this.next = false;
      this.total = 0;
      this.page = 0;
    }

    PagerCtrl.prototype.$onChanges = function(changes) {
      if (this.filter != null) {
        return this.getPages();
      }
    };

    PagerCtrl.prototype.changePage = function(direction) {
      var filter;
      filter = angular.copy(this.filter);
      filter.pagination.page = (function() {
        switch (direction) {
          case 'next':
            return this.filter.pagination.page + 1;
          case 'previous':
            return this.filter.pagination.page - 1;
        }
      }).call(this);
      return this.onUpdate({
        filter: filter
      });
    };

    PagerCtrl.prototype.getPages = function() {
      this.total = Math.ceil(this.filter.pagination.count / this.filter.pagination.per) - 1;
      this.page = this.filter.pagination.page;
      if (this.total > this.page) {
        this.next = true;
      } else {
        this.next = false;
      }
      if (this.page > 0) {
        return this.previous = true;
      } else {
        return this.previous = false;
      }
    };

    return PagerCtrl;

  })();

  angular.module('homemademessClient').component('pager', {
    bindings: {
      filter: '<',
      onUpdate: '&'
    },
    templateUrl: 'app/components/pager/pager.html',
    controller: PagerCtrl
  });

}).call(this);


(function() {
  'use strict';
  var MenuActionsCtrl;

  MenuActionsCtrl = (function() {
    function MenuActionsCtrl(broadcastService, menuService) {
      this.broadcastService = broadcastService;
      this.menuService = menuService;
    }

    MenuActionsCtrl.prototype.$onInit = function() {
      return this.load();
    };

    MenuActionsCtrl.prototype.$onChanges = function(changes) {
      return this.load();
    };

    MenuActionsCtrl.prototype.act = function(action) {
      return this.broadcastService.send(action);
    };

    MenuActionsCtrl.prototype.load = function() {
      return this.menu = this.menuService.getMenu(this.menuname);
    };

    return MenuActionsCtrl;

  })();

  angular.module('homemademessClient').component('menuActions', {
    bindings: {
      context: '<',
      menuname: '@'
    },
    templateUrl: 'app/components/menu/menuActions.html',
    controller: ['broadcastService', 'menuService', MenuActionsCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var MenuCtrl;

  MenuCtrl = (function() {
    function MenuCtrl($rootScope, menuService, broadcastService) {
      this.scope = $rootScope;
      this.menuService = menuService;
      this.broadcastService = broadcastService;
      this.menuOpen = false;
      this.trigger = "menu";
    }

    MenuCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      this.getMenu();
      this.scope.$on('menu.add', function(e, id) {
        return ctrl.getMenu(true);
      });
      this.scope.$on('menu.remove', function(e, id) {
        return ctrl.getMenu();
      });
      this.scope.$on('menu.reload', function(e, open) {
        return ctrl.getMenu(open);
      });
      this.scope.$on('auth.login', function(e, user) {
        return ctrl.getMenu(true);
      });
      return this.scope.$on('auth.logout', function(e, user) {
        return ctrl.getMenu();
      });
    };

    MenuCtrl.prototype.getMenu = function(open) {
      this.menu = this.menuService.getMenu();
      this.trigger = this.menuService.getTrigger();
      return this.menuOpen = typeof open === "boolean" ? open : this.menuOpen;
    };

    MenuCtrl.prototype.act = function(action) {
      return this.broadcastService.send('menu.' + action);
    };

    return MenuCtrl;

  })();

  angular.module('homemademessClient').component('menu', {
    templateUrl: 'app/components/menu/menu.html',
    controller: ['$rootScope', 'menuService', 'broadcastService', MenuCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var FilterCtrl;

  FilterCtrl = (function() {
    function FilterCtrl(filterService, paramService, $scope, $filter) {
      this.filterService = filterService;
      this.paramService = paramService;
      this.$scope = $scope;
      this.filters = [];
      this.showFilters = null;
      this.filterActive = 0;
      this.selected = false;
      this.dateFormat = 'M.D.YY';
    }

    FilterCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      this.selected = this.filter.selected;
      this.showFilters = this.filterService.getDisplay();
      this.filterActive = this.filterService.getActive();
      this.$scope.$on('menu.toggleFilters', function() {
        return ctrl.showFilters = ctrl.filterService.toggleDisplay();
      });
      this.initFilters();
      return this.$scope.$on('params:update:push', function() {
        return ctrl.initFilters();
      });
    };

    FilterCtrl.prototype.$onChanges = function() {
      this.selected = this.filter.selected;
      return this.initFilters();
    };

    FilterCtrl.prototype.updateSelect = function() {
      var filter;
      filter = angular.copy(this.filter);
      filter.selected = this.selected;
      return this.onUpdate({
        filter: filter
      });
    };

    FilterCtrl.prototype.updateActive = function() {
      return this.filterService.setActive(this.filterActive);
    };

    FilterCtrl.prototype.initFilters = function() {
      var ctrl;
      ctrl = this;
      this.filters = [];
      return angular.forEach(this.paramService.getParams(), function(v, k) {
        switch (k) {
          case "tagtext":
            return angular.forEach(v.split('~~'), function(t, i) {
              return ctrl.filters.push({
                'name': "Tag: " + t,
                'key': k,
                'value': v
              });
            });
          case "selected":
            return ctrl.filters.push({
              'name': "Only Selected",
              'key': k
            });
          case "start":
            return ctrl.filters.push({
              'name': "Date >= " + moment(parseInt(v)).format(ctrl.dateFormat),
              'key': k
            });
          case "end":
            return ctrl.filters.push({
              'name': "Date <= " + moment(parseInt(v)).format(ctrl.dateFormat),
              'key': k
            });
          case "up":
            return ctrl.filters.push({
              'name': "Uploaded: " + moment(v).format(ctrl.dateFormat),
              'key': k
            });
        }
      });
    };

    FilterCtrl.prototype.removeFilter = function(filter) {
      var remove, updateFilter;
      updateFilter = angular.copy(this.filter);
      switch (filter.key) {
        case "tagtext":
          remove = updateFilter.tag.tagtext.indexOf(filter.value);
          updateFilter.tag.tagtext.splice(remove, 1);
          break;
        case "selected":
          updateFilter.selected = false;
          break;
        case "start":
          updateFilter.date.from = 0;
          break;
        case "end":
          updateFilter.date.to = 0;
          break;
        case "up":
          updateFilter.date.up = null;
      }
      return this.onUpdate({
        filter: updateFilter
      });
    };

    return FilterCtrl;

  })();

  angular.module('homemademessClient').component('filter', {
    bindings: {
      filter: '<',
      user: '<',
      onUpdate: '&'
    },
    templateUrl: 'app/components/filter/filter.html',
    controller: ['filterService', 'paramService', '$scope', '$filter', FilterCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var AdminCtrl;

  AdminCtrl = (function() {
    function AdminCtrl() {}

    AdminCtrl.prototype.$onInit = function() {
      angular.element(document).find('body').addClass('user-' + this.user.name);
      return angular.element(document).find('body').addClass('role-admin');
    };

    AdminCtrl.prototype.$onDestroy = function() {
      angular.element(document).find('body').removeClass('user-' + this.user.name);
      return angular.element(document).find('body').removeClass('role-admin');
    };

    return AdminCtrl;

  })();

  angular.module('homemademessClient').component('admin', {
    bindings: {
      user: '<',
      view: '<',
      tag: '<'
    },
    templateUrl: 'app/components/admin/admin.html',
    controller: AdminCtrl
  });

}).call(this);


(function() {
  'use strict';
  angular.module('homemademessClient').controller('SettingsCtrl', function($scope, User) {
    $scope.errors = {};
    return $scope.changePassword = function(form) {
      $scope.submitted = true;
      if (form.$valid) {
        return Auth.changePassword($scope.user.oldPassword, $scope.user.newPassword).then(function() {
          return $scope.message = 'Password successfully changed.';
        })["catch"](function() {
          form.password.$setValidity('mongoose', false);
          $scope.errors.other = 'Incorrect password';
          return $scope.message = '';
        });
      }
    };
  });

}).call(this);


(function() {
  'use strict';
  angular.module('homemademessClient').controller('LoginCtrl', function($scope, Auth, $location, $window, apiUrl, $mdDialog) {
    $scope.errors = {};
    $scope.login = function(form) {
      $scope.submitted = true;
      if (form.$valid) {
        return Auth.login({
          email: $scope.view.user.email,
          password: $scope.view.user.password
        }).then(function(u) {
          $scope.view.user = u;
          return $mdDialog.hide();
        })["catch"](function(err) {
          return $scope.errors.other = err.message;
        });
      }
    };
    return $scope.loginOauth = function(provider) {
      return $window.location.href = apiUrl + '/auth/' + provider;
    };
  });

}).call(this);


(function() {
  'use strict';
  var TaggedMenuCtrl;

  TaggedMenuCtrl = (function() {
    function TaggedMenuCtrl(menuService, $scope, $state) {
      this.menuService = menuService;
      this.$scope = $scope;
      this.$state = $state;
      this.bounce = 400;
      this.menuConfig = {
        registerID: 'TaggedState',
        menuMiddle: [
          {
            label: 'Return',
            src: 'arrow_back',
            action: 'home',
            states: ['tagged'],
            roles: ['anon', 'admin', 'download']
          }
        ]
      };
    }

    TaggedMenuCtrl.prototype.$onInit = function() {
      var ctrl;
      ctrl = this;
      ctrl.menuService.registerMenu(ctrl.menuConfig);
      return this.$scope.$on('menu.home', function() {
        return ctrl.$state.go('home', ctrl.previous);
      });
    };

    TaggedMenuCtrl.prototype.$onDestroy = function() {
      return this.menuService.removeMenu(this.menuConfig.registerID);
    };

    return TaggedMenuCtrl;

  })();

  angular.module('homemademessClient').component('taggedMenu', {
    bindings: {
      previous: '<'
    },
    controller: ['menuService', '$scope', '$state', TaggedMenuCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var TaggedCtrl;

  TaggedCtrl = (function() {
    function TaggedCtrl(paramService, broadcastService, Slides, Auth, $window, $scope, $state) {
      this.paramService = paramService;
      this.broadcastService = broadcastService;
      this.Slides = Slides;
      this.Auth = Auth;
      this.$window = $window;
      this.$scope = $scope;
      this.$state = $state;
    }

    TaggedCtrl.prototype.$onInit = function() {
      var ctrl, params;
      ctrl = this;
      this.view.map = this.view.images.map(function(i) {
        return i._id;
      });
      params = this.paramService.getParams();
      if (typeof user === 'undefined' && (params.eagle != null)) {
        this.Auth.login({
          email: this.tag[0].text,
          password: params.eagle
        });
      }
      this.$scope.$on('params:update:recieve', function(e, newParams) {
        params = ctrl.paramService.getParamsObject(ctrl.view.filter);
        params = ctrl.filterTaggedParams(params);
        angular.forEach(newParams, function(v, k) {
          var theyredifferent;
          if (v !== params[k]) {
            return theyredifferent = true;
          }
        });
        if (typeof theyredifferent !== "undefined" && theyredifferent !== null) {
          return ctrl.updateView();
        }
      });
      this.$scope.$on('auth.login', function(e, user) {
        return ctrl.user = user;
      });
      this.$scope.$on('auth.logout', function(e, user) {
        return ctrl.user = user;
      });
      this.$scope.$on('menu.toggleAuth', function() {
        return ctrl.Auth.toggle();
      });
      this.$scope.$on('image.delete.begin', function(e, id) {
        var i;
        i = ctrl.view.map.indexOf(id);
        if (i > -1) {
          return ctrl.view.images[i]["delete"] = true;
        }
      });
      this.$scope.$on('image.delete.complete', function(e, id) {
        var i;
        i = ctrl.view.map.indexOf(id);
        if (i > -1) {
          return ctrl.updateView(ctrl.view.filter);
        }
      });
      this.$scope.$on('image.upload.complete', function(e, img) {
        return ctrl.updateView(ctrl.view.filter);
      });
      return this.$scope.$on('image.update.privacy', function(e, img) {
        return ctrl.updateView(ctrl.view.filter);
      });
    };

    TaggedCtrl.prototype.mapImages = function() {
      return this.view.map = this.view.images.map(function(i) {
        return i._id;
      });
    };

    TaggedCtrl.prototype.recieveFilter = function(filter) {
      var after, ctrl, filterCopy, oldFilter, oldPagination;
      ctrl = this;
      oldFilter = angular.copy(this.view.filter);
      oldPagination = angular.copy(oldFilter.pagination);
      filterCopy = angular.copy(filter);
      if (!this.testEquality(filterCopy, oldFilter)) {
        delete oldFilter.pagination;
        delete filterCopy.pagination;
        if (!this.testEquality(filterCopy, oldFilter)) {
          filter.pagination.page = 0;
        }
        if (!this.testEquality(filter.pagination.page, oldPagination.page)) {
          after = filter.pagination.page > oldPagination.page ? function() {
            return ctrl.$window.scrollTo(0, 0);
          } : function() {
            return ctrl.$window.scrollTo(0, 999999);
          };
        } else {
          after = null;
        }
        filter = this.filterTaggedFilter(filter);
        console.log('recieveFilter', filter);
        return this.updateView(filter, after);
      }
    };

    TaggedCtrl.prototype.updateView = function(filter, after) {
      var ctrl, params, taggedParams;
      ctrl = this;
      params = this.paramService.getParamsObject(filter);
      taggedParams = this.filterTaggedParams(params);
      if (filter != null) {
        this.paramService.updateParams(taggedParams);
      }
      return this.Slides.get(params, function(s) {
        ctrl.view = s;
        ctrl.mapImages();
        ctrl.broadcastService.send('updateView', ctrl.view);
        if (after != null) {
          return after();
        }
      });
    };

    TaggedCtrl.prototype.testEquality = function(obj, obj2) {
      if (!angular.equals(angular.toJson(obj), angular.toJson(obj2))) {
        return false;
      } else {
        return true;
      }
    };

    TaggedCtrl.prototype.filterTaggedParams = function(params) {
      var taggedParams, windowParams;
      taggedParams = angular.copy(params);
      windowParams = this.paramService.getParams();
      delete taggedParams.tagtext;
      if (taggedParams.order === "createDate") {
        delete taggedParams.order;
      }
      if (windowParams.eagle) {
        taggedParams.eagle = windowParams.eagle;
      }
      return taggedParams;
    };

    TaggedCtrl.prototype.filterTaggedFilter = function(filter) {
      if (filter.tagtext === null) {
        filter.tagtext = this.tag[0].text;
      }
      if (filter.order === null) {
        filter.order = "createDate";
      }
      return filter;
    };

    return TaggedCtrl;

  })();

  angular.module('homemademessClient').component('taggedDisplay', {
    bindings: {
      view: '<',
      user: '<',
      tag: '<',
      previous: '<'
    },
    templateUrl: 'app/tagged/tagged.html',
    controller: ['paramService', 'broadcastService', 'Slides', 'Auth', '$window', '$scope', '$state', TaggedCtrl]
  });

}).call(this);


(function() {
  'use strict';
  var User;

  User = function($resource, apiUrl, $cookies) {
    var authHeader;
    authHeader = function(headers) {
      var token;
      token = $cookies.get('token');
      if (token) {
        return 'Bearer ' + token;
      } else {
        return '';
      }
    };
    return $resource(apiUrl + '/users/:id/:controller', {
      id: '@_id'
    }, {
      changePassword: {
        method: 'PUT',
        params: {
          controller: 'password'
        },
        headers: {
          'Authorization': authHeader
        }
      },
      get: {
        method: 'GET',
        params: {
          id: 'me'
        },
        headers: {
          'Authorization': authHeader
        }
      }
    });
  };

  angular.module('homemademessClient').factory('User', ['$resource', 'apiUrl', '$cookies', User]);

}).call(this);


(function() {
  'use strict';
  var Tags;

  Tags = function($resource, apiUrl, $location) {
    var getTags;
    getTags = function() {
      var filter;
      filter = $location.search();
      if (filter.tagtext != null) {
        return filter.tagtext;
      } else {
        return [];
      }
    };
    return $resource(apiUrl + '/tags', {
      text: function() {
        return getTags();
      }
    }, {
      get: {
        method: 'GET',
        isArray: true
      }
    });
  };

  angular.module('homemademessClient').factory('Tags', ['$resource', 'apiUrl', '$location', Tags]);

}).call(this);


(function() {
  'use strict';
  var socketService;

  socketService = function(socketFactory, apiUrl, Auth, $ocLazyLoad, broadcastService, $q) {
    socketService = {
      getIO: function() {
        socketService = this;
        return $q(function(resolve, reject) {
          return $ocLazyLoad.load(apiUrl + '/socket.io-client/socket.io.js').then(function() {
            return resolve(io);
          }, function(e) {
            return reject(e);
          });
        });
      },
      getSocket: function() {
        socketService = this;
        return $q(function(resolve, reject) {
          if (socketService.socket != null) {
            return resolve(socketService.socket);
          } else {
            return socketService.getIO().then(function(ioc) {
              var ioSocket;
              ioSocket = ioc(apiUrl, {
                query: 'token=' + Auth.getToken(),
                path: '/socket.io-client'
              });
              return ioSocket.on('connect', function() {
                socketService.socket = socketFactory({
                  ioSocket: ioSocket
                });
                return resolve(socketService.socket);
              });
            }, function(e) {
              return reject(e);
            });
          }
        });
      },
      init: function() {
        socketService = this;
        return $q(function(resolve, reject) {
          return socketService.getSocket().then(function(sock) {
            return resolve(socketService);
          }, function(e) {
            return reject(e);
          });
        });
      },
      destroy: function() {
        var ref;
        if (((ref = this.socket) != null ? ref.close : void 0) != null) {
          this.socket.close();
          this.socket = void 0;
          return broadcastService.send('socket.close');
        }
      },
      registerListener: function(name, func) {
        var ctrl;
        ctrl = this;
        if (!Array.isArray(name)) {
          name = [name];
        }
        return name.forEach(function(n) {
          this.socket.on(n, function(data) {
            ctrl.broadcastService(n, data);
            if (func != null) {
              return func(data);
            }
          });
          return broadcastService.send('socket.registerListener', name);
        });
      },
      emit: function(name, data) {
        this.socket.emit(name, data);
        return broadcastService.send('socket.emit', name, data);
      }
    };
    return socketService.init().then(function(s) {
      broadcastService.send('socket.init', s);
      return socketService;
    }, function(e) {
      broadcastService.send('socket.init.error', e);
      return e;
    });
  };

  angular.module('homemademessClient').factory('socketService', ['socketFactory', 'apiUrl', 'Auth', '$ocLazyLoad', 'broadcastService', '$q', socketService]);

}).call(this);


(function() {
  'use strict';
  var Slides;

  Slides = function($resource, apiUrl, $location) {
    var getParam;
    getParam = function(q, defaultVal) {
      var filter;
      filter = $location.search();
      if (filter[q] != null) {
        return filter[q];
      } else {
        if (defaultVal != null) {
          return defaultVal;
        } else {
          return null;
        }
      }
    };
    return $resource(apiUrl + '/images/:id', {
      page: function() {
        return getParam('page', 0);
      },
      per: function() {
        return getParam('per', 60);
      },
      tagtext: function() {
        return getParam('tagtext');
      },
      start: function() {
        return getParam('start');
      },
      end: function() {
        return getParam('end');
      },
      up: function() {
        return getParam('up');
      },
      selected: function() {
        return getParam('selected');
      },
      order: function() {
        return getParam('order');
      },
      id: this.id
    }, {
      'get': {
        method: 'GET'
      },
      'save': {
        method: 'POST'
      },
      'query': {
        method: 'GET',
        isArray: true
      },
      'delete': {
        method: 'DELETE'
      },
      'update': {
        method: 'PUT'
      }
    });
  };

  angular.module('homemademessClient').factory('Slides', ['$resource', 'apiUrl', '$location', Slides]);

}).call(this);


(function() {
  'use strict';
  var selectService;

  selectService = function($resource, apiUrl, paramService, broadcastService) {
    var api;
    api = $resource(apiUrl + '/select/:id', {
      id: this.id
    }, {
      get: {
        method: 'GET',
        isArray: true
      },
      select: {
        method: 'POST'
      },
      deselect: {
        method: 'DELETE'
      },
      selectAll: {
        method: 'POST',
        isArray: true
      },
      deselectAll: {
        method: 'DELETE'
      }
    });
    selectService = {
      selected: [],
      init: function() {
        var ctrl;
        ctrl = this;
        return api.get(function(s) {
          return ctrl.selected = s;
        }, function(e) {
          return console.log(e);
        }).$promise;
      },
      getSelected: function() {
        return this.selected;
      },
      isEmpty: function() {
        var answer;
        return answer = this.selected.length === 0 ? true : false;
      },
      isFull: function(count) {
        var answer;
        return answer = this.selected.length === count ? true : false;
      },
      none: function() {
        var ctrl;
        ctrl = this;
        return api.deselectAll(paramService.getParams(), function(r) {
          ctrl.selected = [];
          broadcastService.send('select.none');
          return broadcastService.send('menu.reload', false);
        }, function(e) {
          return console.log(e);
        }).$promise;
      },
      all: function() {
        var ctrl;
        ctrl = this;
        return api.selectAll({
          query: paramService.getParams()
        }, function(s) {
          ctrl.selected = ctrl.selected.concat(s.filter(function(item) {
            return ctrl.selected.indexOf(item) < 0;
          }));
          broadcastService.send('select.all');
          return broadcastService.send('menu.reload', true);
        }, function(e) {
          return console.log(e);
        }).$promise;
      },
      toggle: function(id) {
        var ctrl, i;
        ctrl = this;
        i = this.selected.indexOf(id);
        if (i === -1) {
          return api.select({
            id: id
          }, {}, function(s) {
            if (s._id === id) {
              ctrl.selected.push(id);
              broadcastService.send('select.on', id);
              return broadcastService.send('menu.reload');
            }
          }).$promise;
        } else {
          return api.deselect({
            id: id
          }, function(s) {
            if (s._id === id) {
              ctrl.selected.splice(i, 1);
              broadcastService.send('select.off', id);
              return broadcastService.send('menu.reload');
            }
          }).$promise;
        }
      }
    };
    return selectService;
  };

  angular.module('homemademessClient').factory('selectService', ['$resource', 'apiUrl', 'paramService', 'broadcastService', selectService]);

}).call(this);


(function() {
  'use strict';
  var queueService;

  queueService = function($resource, apiUrl) {
    var api;
    api = $resource(apiUrl + '/up', {
      id: this.id
    }, {
      get: {
        method: 'GET'
      }
    });
    queueService = {
      get: function() {
        var ctrl;
        ctrl = this;
        return api.get(function(q) {
          return ctrl.q = q;
        }, function(e) {
          return console.log(e);
        }).$promise;
      }
    };
    return queueService;
  };

  angular.module('homemademessClient').factory('queueService', ['$resource', 'apiUrl', queueService]);

}).call(this);


(function() {
  'use strict';
  var Public;

  Public = function($resource, apiUrl) {
    return $resource(apiUrl + '/public/:id', {
      id: this.id
    }, {
      one: {
        method: 'GET',
        cache: false
      },
      many: {
        method: 'POST'
      }
    });
  };

  angular.module('homemademessClient').factory('Public', ['$resource', 'apiUrl', Public]);

}).call(this);


(function() {
  'use strict';
  var Private;

  Private = function($resource, apiUrl) {
    return $resource(apiUrl + '/private/:id', {
      id: this.id
    }, {
      one: {
        method: 'GET',
        cache: false
      },
      many: {
        method: 'POST'
      }
    });
  };

  angular.module('homemademessClient').factory('Private', ['$resource', 'apiUrl', Private]);

}).call(this);


(function() {
  'use strict';
  var paramService;

  paramService = function($rootScope, $location, broadcastService, $httpParamSerializer) {
    var paramsService;
    paramsService = {
      getParams: function() {
        return $location.search();
      },
      cleanParams: function(params) {
        Object.keys(params).forEach(function(key) {
          if (params[key] === null) {
            return delete params[key];
          }
        });
        return params;
      },
      updateParams: function(params) {
        params = this.cleanParams(params);
        angular.forEach(params, function(param, i) {
          return $location.search(i, param);
        });
        angular.forEach($location.search(), function(v, k) {
          if (!params[k]) {
            return $location.search(k, null);
          }
        });
        return broadcastService.send('params:update:push', params);
      },
      getParamsObject: function(filter) {
        var params;
        params = {};
        if (typeof filter === 'object') {
          params.tagtext = filter.tag.tagtext.length > 0 ? this.arrayToParam(filter.tag.tagtext, '~~') : null;
          params.page = filter.pagination.page > 0 ? filter.pagination.page : null;
          params.per = filter.pagination.per !== 60 ? filter.pagination.per : null;
          params.order = !angular.equals(filter.order, {
            createDate: "desc"
          }) ? this.orderToParam(filter.order) : null;
          params.selected = filter.selected ? filter.selected : null;
          params.start = filter.date.from !== 0 ? filter.date.from : null;
          params.end = filter.date.to !== 0 ? filter.date.to : null;
          params.up = filter.date.up ? filter.date.up : null;
        }
        return this.cleanParams(params);
      },
      arrayToParam: function(arr, glue) {
        var param;
        param = '';
        angular.forEach(arr, function(val, key) {
          if (param.length > 0) {
            param += glue;
          }
          return param += val.replace(/\s/g, '_');
        });
        return param;
      },
      orderToParam: function(ord) {
        var param;
        param = '';
        angular.forEach(ord, function(val, key) {
          if (param.length > 0) {
            param += ',';
          }
          param += key;
          if (val === 'desc') {
            return param += '-';
          }
        });
        return param;
      },
      paramsToString: function() {
        var str;
        str = $httpParamSerializer(this.getParams());
        if (str.length > 0) {
          return "?" + str;
        } else {
          return "";
        }
      },
      init: function() {
        var ctrl;
        ctrl = this;
        $rootScope.$watch(function() {
          return $location.search();
        }, function(newSearch, oldSearch) {
          var params;
          if (!angular.equals(newSearch, oldSearch)) {
            params = ctrl.cleanParams(newSearch);
            return broadcastService.send('params:update:recieve', params);
          }
        });
        return ctrl;
      }
    };
    return paramsService.init();
  };

  angular.module('homemademessClient').factory('paramService', ['$rootScope', '$location', 'broadcastService', '$httpParamSerializer', paramService]);

}).call(this);


(function() {
  'use strict';
  var menuService;

  menuService = function($state, broadcastService, Auth, lodash) {
    return {
      menuStart: [
        {
          label: 'Filter',
          src: 'filter_list',
          action: 'toggleFilters',
          states: ['home'],
          roles: ['anon', 'admin', 'download']
        }
      ],
      menuMiddle: {},
      menuEnd: [
        {
          label: 'Settings',
          src: 'settings',
          action: 'settings',
          states: ['home', 'tagged'],
          roles: ['admin']
        }, {
          label: 'Log In',
          src: 'vpn_key',
          action: 'toggleAuth',
          states: ['home', 'tagged'],
          roles: ['anon']
        }, {
          label: 'Log Out',
          src: 'exit_to_app',
          action: 'toggleAuth',
          states: ['home', 'tagged'],
          roles: ['admin']
        }
      ],
      filterMenu: {},
      filterTrigger: {},
      getMenu: function(menuname) {
        var ctrl, menu, role, state;
        ctrl = this;
        if (menuname == null) {
          menu = this.menuStart;
          angular.forEach(this.menuMiddle, function(extra, k) {
            if (Array.isArray(extra)) {
              return menu = menu.concat(extra);
            }
          });
          menu = menu.concat(this.menuEnd);
        } else {
          menu = [];
          angular.forEach(this[menuname], function(menuitem, k) {
            if (Array.isArray(menuitem)) {
              return menu = menu.concat(menuitem);
            }
          });
        }
        role = this.getUserRole();
        state = this.getState();
        return menu = lodash.filter(menu, function(item) {
          var i;
          i = lodash.intersection(item.roles, role);
          if (i.length > 0) {
            i = lodash.intersection(item.states, lodash.words(state));
          }
          if (i.length > 0) {
            lodash.each(ctrl.filterMenu, function(f, k) {
              return i = f(item, i, k);
            });
          }
          return i.length;
        });
      },
      getTrigger: function() {
        var ctrl, trigger;
        ctrl = this;
        trigger = "menu";
        angular.forEach(this.filterTrigger, function(f, k) {
          return trigger = f(trigger);
        });
        return trigger;
      },
      getUserRole: function() {
        var role, user;
        user = Auth.getCurrentUser();
        role = (user != null ? user.role : void 0) != null ? user.role : 'anon';
        if (!Array.isArray(role)) {
          return role = [role];
        }
      },
      getState: function() {
        return $state.current.name;
      },
      registerMenu: function(config) {
        var ctrl, id;
        if (config.registerID != null) {
          ctrl = this;
          id = config.registerID;
          angular.forEach(config, function(prop, propname) {
            if (propname !== 'registerID') {
              if (typeof ctrl[propname] === 'undefined') {
                ctrl[propname] = {};
              }
              return ctrl[propname][id] = prop;
            }
          });
          return broadcastService.send('menu.add', config);
        }
      },
      removeMenu: function(id) {
        var attrs, ctrl;
        ctrl = this;
        attrs = ['menuExtra', 'filterMenu', 'filterTrigger'];
        angular.forEach(this, function(menu, name) {
          if (ctrl[name][id] != null) {
            return delete ctrl[name][id];
          }
        });
        return broadcastService.send('menu.remove', id);
      }
    };
  };

  angular.module('homemademessClient').factory('menuService', ['$state', 'broadcastService', 'Auth', 'lodash', menuService]);

}).call(this);


(function() {
  'use strict';
  var filterService;

  filterService = function($resource, apiUrl, $cookies, broadcastService) {
    var api;
    api = $resource(apiUrl + '/info/:id', {
      id: this.id
    }, {
      getArray: {
        method: 'GET',
        isArray: true
      }
    });
    filterService = {
      setDisplay: function(set) {
        if (set) {
          return $cookies.put('showFilter', 1);
        } else {
          return $cookies.put('showFilter', null);
        }
      },
      getDisplay: function() {
        var display;
        display = $cookies.get('showFilter');
        switch (display) {
          case '1':
            return true;
          default:
            return false;
        }
      },
      setActive: function(i) {
        return $cookies.put('activeFilter', i);
      },
      getActive: function() {
        return $cookies.get('activeFilter');
      },
      toggleDisplay: function() {
        var display;
        display = !this.getDisplay();
        this.setDisplay(display);
        broadcastService.send('filterService.toggleDisplay', display);
        return display;
      },
      getDateBoundaries: function() {
        return api.get({
          id: 'dates'
        }, function(r) {
          return r;
        }, function(e) {
          return console.log(e);
        }).$promise;
      },
      getUploadDates: function() {
        return api.getArray({
          id: 'up'
        }, function(r) {
          return r;
        }, function(e) {
          return console.log(e);
        }).$promise;
      }
    };
    filterService.display = filterService.getDisplay();
    return filterService;
  };

  angular.module('homemademessClient').factory('filterService', ['$resource', 'apiUrl', '$cookies', 'broadcastService', filterService]);

}).call(this);


(function() {
  'use strict';
  var dropzoneService;

  dropzoneService = function(apiUrl, broadcastService, Auth) {
    return {
      headers: {
        'Authorization': 'Bearer ' + Auth.getToken()
      },
      init: function() {
        var ctrl;
        ctrl = this;
        if (this.tag) {
          this.headers.HMMTag = this.tag._id;
        }
        this.dropzone = new Dropzone('body', {
          url: apiUrl + '/up',
          headers: ctrl.headers,
          parallelUploads: 1,
          previewsContainer: 'upload-info',
          maxFilesize: 999,
          timeout: 90000,
          acceptedFiles: 'image/*,video/*',
          init: function() {
            this.on('drop', function(e) {
              ctrl.update();
              return broadcastService.send('dropzone.drop', e);
            });
            this.on('addedfile', function(f) {
              ctrl.update();
              return broadcastService.send('dropzone.addedfile', f);
            });
            this.on('success', function(f, res) {
              ctrl.update();
              return broadcastService.send('dropzone.success', {
                file: f,
                res: res
              });
            });
            this.on('error', function(f, msg) {
              ctrl.update();
              return broadcastService.send('dropzone.error', {
                file: f,
                msg: msg
              });
            });
            this.on('canceled', function(f) {
              ctrl.update();
              return broadcastService.send('dropzone.canceled', f);
            });
            this.on('removedfile', function(f) {
              ctrl.update();
              return broadcastService.send('dropzone.removedfile', f);
            });
            this.on('totaluploadprogress', function(total, totalBytes, totalSent) {
              return broadcastService.send('dropzone.progress', total);
            });
            return this.on('queuecomplete', function() {
              return broadcastService.send('dropzone.queuecomplete', arguments);
            });
          }
        });
        if (this.dropzone != null) {
          return broadcastService.send('dropzone.init');
        }
      },
      destroy: function() {
        this.dropzone.destroy();
        return this.dropzone = void 0;
      },
      update: function() {
        return broadcastService.send('dropzone.update', {
          processing: this.dropzone.getAcceptedFiles(),
          rejected: this.dropzone.getRejectedFiles(),
          queued: this.dropzone.getQueuedFiles(),
          uploading: this.dropzone.getUploadingFiles()
        });
      },
      setHeaders: function(headers) {
        var ctrl;
        ctrl = this;
        return angular.forEach(headers, function(v, k) {
          return ctrl.headers[k] = v;
        });
      },
      removeHeader: function(name) {
        if (this.headers[name]) {
          return delete this.headers[name];
        }
      },
      toggle: function(op) {
        if (op == null) {
          if (this.dropzone != null) {
            op = 'destroy';
          } else {
            op = 'init';
          }
        }
        switch (op) {
          case 'init':
            if (this.dropzone == null) {
              this.init();
              if (this.dropzone != null) {
                return broadcastService.send('dropzone.init');
              }
            }
            break;
          case 'destroy':
            if (this.dropzone != null) {
              this.destroy();
              if (this.dropzone == null) {
                return broadcastService.send('dropzone.destroy');
              }
            }
        }
      }
    };
  };

  angular.module('homemademessClient').factory('dropzoneService', ['apiUrl', 'broadcastService', 'Auth', dropzoneService]);

}).call(this);


(function() {
  'use strict';
  var Download;

  Download = function($resource, apiUrl) {
    return $resource(apiUrl + '/file/:id', {
      id: this.id
    }, {
      one: {
        method: 'GET',
        cache: false,
        transformResponse: function(data, headers) {
          return {
            response: data
          };
        }
      },
      many: {
        method: 'POST',
        transformResponse: function(data, headers) {
          return {
            response: data
          };
        }
      }
    });
  };

  angular.module('homemademessClient').factory('Download', ['$resource', 'apiUrl', Download]);

}).call(this);


(function() {
  'use strict';
  var broadcastService;

  broadcastService = function($rootScope, debug) {
    return {
      send: function() {
        var args;
        args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
        $rootScope.$broadcast.apply($rootScope, args);
        if (debug) {
          return console.log.apply($rootScope, args);
        }
      }
    };
  };

  angular.module('homemademessClient').factory('broadcastService', ['$rootScope', 'debug', broadcastService]);

}).call(this);


(function() {
  'use strict';
  var Auto;

  Auto = function($resource, apiUrl) {
    return $resource(apiUrl + '/auto');
  };

  angular.module('homemademessClient').factory('Auto', ['$resource', 'apiUrl', Auto]);

}).call(this);


(function() {
  'use strict';
  var authService;

  authService = function($http, User, $cookies, $mdDialog, apiUrl, broadcastService) {
    var currentUser;
    currentUser = $cookies.get('token') ? User.get({}, function(u) {
      if (u.role = 'admin' || (u.role = 'download')) {
        return $http.defaults.headers.common.Authorization = 'Bearer ' + $cookies.get('token');
      }
    }, function(e) {
      $cookies.remove('token');
      return delete $http.defaults.headers.common.Authorization;
    }) : {};
    return {

      /*
      Authenticate user and save token
      
      @param  {Object}   user     - login info
      @param  {Function} callback - optional
      @return {Promise}
       */
      login: function(user, callback) {
        return $http.post(apiUrl + '/auth/local', {
          email: user.email,
          password: user.password
        }).then(function(res) {
          var now;
          now = new Date();
          $cookies.put('token', res.data.token, {
            expires: new Date(now.getTime() + (4 * 60 * 60 * 1000))
          });
          $http.defaults.headers.common.Authorization = 'Bearer ' + res.data.token;
          currentUser = User.get();
          if (typeof callback === "function") {
            callback(res, currentUser);
          }
          broadcastService.send('auth.login', currentUser);
          return currentUser;
        }, (function(_this) {
          return function(err) {
            _this.logout();
            if (typeof callback === "function") {
              callback(err);
            }
            return err;
          };
        })(this));
      },

      /*
      Delete access token and user info
      
      @param  {Function}
       */
      logout: function() {
        $cookies.remove('token');
        delete $http.defaults.headers.common.Authorization;
        currentUser = {};
        broadcastService.send('auth.logout', currentUser);
      },

      /*
      Create a new user
      
      @param  {Object}   user     - user info
      @param  {Function} callback - optional
      @return {Promise}
       */
      createUser: function(user, callback) {
        return User.save(user, function(data) {
          $cookies.put('token', data.token);
          currentUser = User.get();
          return typeof callback === "function" ? callback(user) : void 0;
        }, (function(_this) {
          return function(err) {
            _this.logout();
            return typeof callback === "function" ? callback(err) : void 0;
          };
        })(this)).$promise;
      },

      /*
      Change password
      
      @param  {String}   oldPassword
      @param  {String}   newPassword
      @param  {Function} callback    - optional
      @return {Promise}
       */
      changePassword: function(oldPassword, newPassword, callback) {
        return User.changePassword({
          id: currentUser._id
        }, {
          oldPassword: oldPassword,
          newPassword: newPassword
        }, function(user) {
          return typeof callback === "function" ? callback(user) : void 0;
        }, function(err) {
          return typeof callback === "function" ? callback(err) : void 0;
        }).$promise;
      },

      /*
      Gets all available info on authenticated user
      
      @return {Object} user
       */
      getCurrentUser: function() {
        return currentUser;
      },

      /*
      Check if a user is logged in synchronously
      
      @return {Boolean}
       */
      isLoggedIn: function() {
        return currentUser.hasOwnProperty('role');
      },

      /*
      Waits for currentUser to resolve before checking if user is logged in
       */
      isLoggedInAsync: function(callback) {
        if (currentUser.hasOwnProperty('$promise')) {
          return currentUser.$promise.then(function() {
            if (typeof callback === "function") {
              callback(true);
            }
          })["catch"](function() {
            if (typeof callback === "function") {
              callback(false);
            }
          });
        } else {
          return typeof callback === "function" ? callback(currentUser.hasOwnProperty('role')) : void 0;
        }
      },

      /*
      Check if a user is an admin
      
      @return {Boolean}
       */
      isAdmin: function() {
        return currentUser.role === 'admin';
      },

      /*
      Get auth token
       */
      getToken: function() {
        return $cookies.get('token');
      },
      toggle: function() {
        var ctrl;
        ctrl = this;
        return ctrl.isLoggedInAsync(function(loggedIn) {
          if (loggedIn) {
            return ctrl.logout();
          } else {
            return $mdDialog.show({
              clickOutsideToClose: true,
              templateUrl: 'app/account/login/login.html',
              controller: 'LoginCtrl'
            });
          }
        });
      }
    };
  };

  angular.module('homemademessClient').factory('Auth', ['$http', 'User', '$cookies', '$mdDialog', 'apiUrl', 'broadcastService', authService]);

}).call(this);


(function() {
  'use strict';
  angular.module('homemademessClient').controller('MainCtrl', [
    '$scope', '$window', 'view', 'user', 'tag', 'Slides', 'Tags', 'Auth', 'paramService', 'broadcastService', function($scope, $window, view, user, tag, Slides, Tags, Auth, paramService, broadcastService) {
      var mapImages, testEquality, updateView;
      $scope.view = view;
      $scope.user = user;
      $scope.view.filter.tag.tags = tag;
      mapImages = function() {
        return $scope.view.map = $scope.view.images.map(function(i) {
          return i._id;
        });
      };
      mapImages();
      updateView = function(filter) {
        var params;
        params = paramService.getParamsObject(filter);
        if (filter != null) {
          paramService.updateParams(params);
        }
        return Slides.get(params, function(s) {
          $scope.view = s;
          mapImages();
          return broadcastService.send('updateView', $scope.view);
        });
      };
      testEquality = function(obj, obj2) {
        if (!angular.equals(angular.toJson(obj), angular.toJson(obj2))) {
          return false;
        } else {
          return true;
        }
      };
      $scope.recieveFilter = function(filter) {
        var filterCopy, oldFilter, oldPagination;
        oldFilter = angular.copy($scope.view.filter);
        oldPagination = angular.copy(oldFilter.pagination);
        filterCopy = angular.copy(filter);
        if (!testEquality(filterCopy, oldFilter)) {
          delete oldFilter.pagination;
          delete filterCopy.pagination;
          if (!testEquality(filterCopy, oldFilter)) {
            filter.pagination.page = 0;
          }
          if (!testEquality(filter.pagination.page, oldPagination.page)) {
            $window.scrollTo(0, 0);
          }
          return updateView(filter);
        } else {
          return console.log(filterCopy, oldFilter);
        }
      };
      $scope.$on('params:update:recieve', function(newParams) {
        updateView();
        if (newParams.tags != null) {
          return Tags.get({}, function(t) {
            return $scope.view.filter.tag.tags = t;
          }, function(e) {
            return console.log(e);
          });
        }
      });
      $scope.$on('auth.login', function(e, user) {
        $scope.user = user;
        return updateView();
      });
      $scope.$on('auth.logout', function(e, user) {
        $scope.user = user;
        return updateView();
      });
      $scope.$on('menu.toggleAuth', function() {
        return Auth.toggle();
      });
      $scope.$on('image.delete.begin', function(e, id) {
        var i;
        i = $scope.view.map.indexOf(id);
        if (i > -1) {
          return $scope.view.images[i]["delete"] = true;
        }
      });
      $scope.$on('image.delete.complete', function(e, id) {
        var i;
        i = $scope.view.map.indexOf(id);
        if (i > -1) {
          return updateView();
        }
      });
      $scope.$on('image.upload.complete', function(e, img) {
        return updateView();
      });
      return $scope.$on('image.update.privacy', function(e, img) {
        return updateView();
      });
    }
  ]);

}).call(this);


(function() {
  'use strict';
  angular.module('homemademessClient').directive('onLongPress', [
    '$timeout', '$parse', function($timeout, $parse) {
      return {
        restrict: 'A',
        link: function(scope, elem, attrs) {
          var delay, fn, timeoutHandler;
          timeoutHandler = '';
          fn = $parse(attrs.onLongPress);
          delay = attrs.delay != null ? attrs.delay : 600;
          elem.bind('touchstart', function(event) {
            scope.longTouchTriggered = false;
            return timeoutHandler = $timeout(function() {
              if (scope.longTouchTriggered && event.preventDefault) {
                event.preventDefault();
              }
              return fn(scope, {
                $event: event
              });
            }, delay);
          });
          elem.bind('touchmove', function(event) {
            return $timeout.cancel(timeoutHandler);
          });
          return elem.bind('touchend', function(event) {
            scope.longTouchTriggered = true;
            return $timeout.cancel(timeoutHandler);
          });
        }
      };
    }
  ]);

}).call(this);


(function() {
  'use strict';
  angular.module('homemademessClient').config(function($stateProvider) {
    return $stateProvider.state('login', {
      url: '/login',
      templateUrl: 'app/account/login/login.html',
      controller: 'LoginCtrl'
    }).state('settings', {
      url: '/settings',
      templateUrl: 'app/account/settings/settings.html',
      controller: 'SettingsCtrl',
      authenticate: true
    });
  });

}).call(this);


(function() {
  angular.module('homemademessClient').run(function($log) {
    'ngInject';
    return $log.debug('runBlock end');
  });

}).call(this);


(function() {
  angular.module('homemademessClient').config(function($stateProvider, $urlRouterProvider) {
    'ngInject';
    $stateProvider.state('home', {
      url: '/?{tagtext}&{page:int}&{per:int}&{start:int}&{end:int}&{selected}&{up}&{order}',
      templateUrl: 'app/main/main.html',
      controller: 'MainCtrl',
      resolve: {
        user: function(Auth) {
          return Auth.getCurrentUser().$promise;
        },
        view: function(Slides, user) {
          return Slides.get({}, function(s) {
            return s.data;
          }).$promise;
        },
        tag: function(Tags, $location) {
          if ($location.search().tagtext != null) {
            return Tags.get({}, function(t) {
              return t;
            }).$promise;
          } else {
            return [];
          }
        }
      },
      params: {
        page: {
          dynamic: true
        },
        per: {
          dynamic: true
        },
        tagtext: {
          dynamic: true
        },
        start: {
          dynamic: true
        },
        end: {
          dynamic: true
        },
        selected: {
          dynamic: true
        },
        up: {
          dynamic: true
        },
        order: {
          dynamic: true
        }
      }
    }).state('home.slideshow', {
      url: 'slide/',
      views: {
        'slideshow@home': 'slideshow'
      }
    }).state('home.slideshow.slide', {
      url: ':slide/',
      component: 'slide'
    }).state('tagged', {
      url: '/tagged/:tag/?{page:int}&{per:int}&{order}&{eagle}',
      component: 'taggedDisplay',
      resolve: {
        user: function(Auth) {
          return Auth.getCurrentUser().$promise;
        },
        view: function(Slides, $transition$, user) {
          return Slides.get({
            tagtext: $transition$.params().tag,
            order: 'createDate'
          }, function(s) {
            return s.data;
          }).$promise;
        },
        tag: function(Tags, $transition$) {
          return Tags.get({
            text: $transition$.params().tag
          }, function(t) {
            return t.data;
          }).$promise;
        },
        previous: function($transition$) {
          return $transition$.params('from');
        }
      },
      params: {
        page: {
          dynamic: true
        },
        per: {
          dynamic: true
        },
        order: {
          dynamic: true
        },
        eagle: {
          dynamic: true
        }
      }
    }).state('tagged.slideshow', {
      url: 'slide/',
      views: {
        'slideshow@tagged': 'slideshow'
      }
    }).state('tagged.slideshow.slide', {
      url: ':slide/',
      component: 'slide'
    });
    return $urlRouterProvider.otherwise('/');
  });

}).call(this);


(function() {
  angular.module('homemademessClient').filter('taglink', function() {
    return function(input) {
      return input.replace(/\s/g, '_');
    };
  }).filter('fromUTC', function() {
    return function(input, form) {
      return moment(input).format(form);
    };
  });

}).call(this);


(function() {
  'use strict';
  angular.module('homemademessClient').constant('apiUrl', location.protocol + '//' + 'api.homemademess.com').constant('debug', true);

}).call(this);


(function() {
  angular.module('homemademessClient').config(function($logProvider) {
    'ngInject';
    return $logProvider.debugEnabled(true);
  }).config(function($cookiesProvider) {
    'ngInject';
    return $cookiesProvider.defaults.domain = Location.host;
  });

}).call(this);


angular.module("homemademessClient").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container main\"><touch></touch><socket></socket><filter filter=\"view.filter\" user=\"user\" on-update=\"recieveFilter(filter)\"></filter><menu user=\"user\"></menu><div ui-view=\"slideshow\" user=\"user\" view=\"view\" on-update=\"recieveFilter(filter)\"></div><div ui-view=\"\"></div><slides view=\"view\" user=\"user\"></slides><div id=\"bottom\"><pager filter=\"view.filter\" on-update=\"recieveFilter(filter)\"></pager><div ng-if=\"user.role==\'admin\'\" class=\"admin\"><admin user=\"user\" view=\"view\" touch=\"touch\"></admin></div></div><footer class=\"footer\"><div class=\"container\"><p>homemademess.com | <a href=\"https://github.com/markisatacomputer/homemademess\">github</a></p></div></footer></div>");
$templateCache.put("app/main/main.slideshow.html","<slideshow slides=\"view.images\"></slideshow>");
$templateCache.put("app/tagged/tagged.html","<div class=\"container main\"><touch></touch><socket></socket><menu user=\"$ctrl.user\"></menu><tagged-menu previous=\"$ctrl.previous\"></tagged-menu><h1 class=\"tag\">{{$ctrl.tag[0].text}}</h1><div ng-if=\"$ctrl.user.role==\'admin\'\" class=\"download-link\"><a href=\"/#!/tagged/{{$ctrl.tag[0].text | taglink }}/?eagle={{$ctrl.tag[0]._id}}\">Download Link</a></div><div ui-view=\"slideshow\" user=\"$ctrl.user\" view=\"$ctrl.view\" on-update=\"$ctrl.recieveFilter(filter)\"></div><slides view=\"$ctrl.view\" user=\"$ctrl.user\"></slides><div id=\"bottom\"><pager filter=\"$ctrl.view.filter\" on-update=\"$ctrl.recieveFilter(filter)\"></pager><div ng-if=\"$ctrl.user.role==\'admin\'\" class=\"admin\"><admin user=\"$ctrl.user\" view=\"$ctrl.view\" tag=\"$ctrl.tag\" touch=\"touch\"></admin></div><div ng-if=\"$ctrl.user.role==\'download\'\" class=\"download\"><download-control></download-control><select-control view=\"$ctrl.view\"></select-control></div></div><footer class=\"footer\"><div class=\"container\"><p>homemademess.com | <a href=\"https://github.com/markisatacomputer/homemademess\">github</a></p></div></footer></div>");
$templateCache.put("app/account/login/login.html","<md-dialog><md-dialog-content><div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><h1>Login</h1></div><div class=\"col-sm-12\"><form name=\"form\" ng-submit=\"login(form)\" novalidate=\"\" class=\"form\"><div class=\"form-group\"><label>Email</label> <input type=\"text\" name=\"email\" ng-model=\"view.user.email\" class=\"form-control\"></div><div class=\"form-group\"><label>Password</label> <input type=\"password\" name=\"password\" ng-model=\"view.user.password\" class=\"form-control\"></div><div class=\"form-group has-error\"><p ng-show=\"form.email.$error.required &amp;&amp; form.password.$error.required &amp;&amp; submitted\" class=\"help-block\">Please enter your email and password.</p><p class=\"help-block\">{{ errors.other }}</p></div><div><button type=\"submit\" class=\"btn btn-inverse btn-lg btn-login\">Login</button></div></form></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/account/settings/settings.html","<div class=\"container\"><div class=\"row\"><div class=\"col-sm-12\"><h1>Change Password</h1></div><div class=\"col-sm-12\"><form name=\"form\" ng-submit=\"changePassword(form)\" novalidate=\"\" class=\"form\"><div class=\"form-group\"><label>Current Password</label> <input type=\"password\" name=\"password\" ng-model=\"user.oldPassword\" mongoose-error=\"\" class=\"form-control\"><p ng-show=\"form.password.$error.mongoose\" class=\"help-block\">{{ errors.other }}</p></div><div class=\"form-group\"><label>New Password</label> <input type=\"password\" name=\"newPassword\" ng-model=\"user.newPassword\" ng-minlength=\"3\" required=\"\" class=\"form-control\"><p ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) &amp;&amp; (form.newPassword.$dirty || submitted)\" class=\"help-block\">Password must be at least 3 characters.</p></div><p class=\"help-block\">{{ message }}</p><button type=\"submit\" class=\"btn btn-lg btn-primary\">Save changes</button></form></div></div></div>");
$templateCache.put("app/components/admin/admin.html","<dropzone tag=\"$ctrl.tag\"></dropzone><select-control view=\"$ctrl.view\"></select-control><tag-control></tag-control><download-control></download-control><private-control></private-control><delete-control></delete-control>");
$templateCache.put("app/components/filter/filter.html","<div ng-class=\"{open:$ctrl.showFilters, closed:!$ctrl.showFilters}\" class=\"filter-wrap\"><md-chips ng-model=\"$ctrl.filters\" md-removeable=\"true\" md-on-remove=\"$ctrl.removeFilter($chip)\" class=\"filters\"><md-chip-template><span><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips><div ng-if=\"$ctrl.showFilters\" ng-swipe-up=\"$ctrl.showFilters = $ctrl.filterService.toggleDisplay()\" class=\"filter-body\"><md-tabs md-selected=\"$ctrl.filterActive\" md-center-tabs=\"true\" class=\"md-dynamic-height\"><md-tab id=\"search\" md-on-select=\"$ctrl.updateActive()\"><md-tab-label aria-label=\"Search Tags\"><md-icon class=\"material-icons\">search</md-icon></md-tab-label><md-tab-body><p>Filter by tag.</p><searchbar filter=\"$ctrl.filter\" on-update=\"$ctrl.onUpdate({filter:filter})\"></searchbar></md-tab-body></md-tab><md-tab id=\"selected\" ng-if=\"$ctrl.user.role == \'admin\'\" md-on-select=\"$ctrl.updateActive()\"><md-tab-label aria-label=\"Show Selected\"><md-icon class=\"material-icons\">check_circle</md-icon></md-tab-label><md-tab-body><p>Filter results to show only selected images.</p><md-switch ng-model=\"$ctrl.selected\" aria-label=\"Show Selected Only\" ng-change=\"$ctrl.updateSelect()\"><span ng-show=\"$ctrl.filter.selected\">Showing only selected images</span><span ng-show=\"!$ctrl.filter.selected\">Showing all images</span></md-switch></md-tab-body></md-tab><md-tab ng-if=\"$ctrl.user.role == \'admin\'\" md-on-select=\"$ctrl.updateActive()\"><md-tab-label aria-label=\"Upload Date\"><md-icon class=\"material-icons\">cloud_upload</md-icon></md-tab-label><md-tab-body><p>Filter by upload date.</p><upload-date filter=\"$ctrl.filter\" on-update=\"$ctrl.showFilters = $ctrl.onUpdate({filter:filter})\"></upload-date></md-tab-body></md-tab><md-tab md-on-select=\"$ctrl.updateActive()\"><md-tab-label aria-label=\"Date Range\"><md-icon class=\"material-icons\">event</md-icon></md-tab-label><md-tab-body><p>Filter by date range.</p><date-range filter=\"$ctrl.filter\" on-update=\"$ctrl.showFilters = $ctrl.onUpdate({filter:filter})\"></date-range></md-tab-body></md-tab></md-tabs><div class=\"close\"><md-button ng-click=\"$ctrl.showFilters = $ctrl.filterService.toggleDisplay()\"><md-icon class=\"material-icons\">close</md-icon></md-button></div></div></div>");
$templateCache.put("app/components/menu/menu.html","<div class=\"navvy\"><div class=\"menu container\"><md-fab-speed-dial md-direction=\"down\" md-open=\"$ctrl.menuOpen\" ng-mouseenter=\"$ctrl.menuOpen=true\" ng-mouseleave=\"$ctrl.menuOpen=false\" class=\"md-fling md-hover-full\"><md-fab-trigger><md-button aria-label=\"Menu\" class=\"md-fab\"><md-icon class=\"material-icons\">{{$ctrl.trigger}}</md-icon></md-button></md-fab-trigger><md-fab-actions><md-button ng-repeat=\"item in $ctrl.menu\" aria-label=\"{{item.label}}\" ng-class=\"item.action.split(\'.\')\" ng-click=\"$ctrl.act(item.action)\" ng-href=\"{{item.href}}\" class=\"md-fab md-raised md-mini {{item.src}}\"><md-tooltip md-direction=\"left\">{{item.label}}</md-tooltip><md-icon class=\"material-icons\">{{item.src}}</md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div>");
$templateCache.put("app/components/menu/menuActions.html","<md-fab-actions><md-button ng-repeat=\"item in $ctrl.menu\" aria-label=\"{{item.label}}\" ng-class=\"item.action.split(\'.\')\" ng-click=\"$ctrl.act(item.action)\" ng-href=\"{{item.href}}\" class=\"md-fab md-raised md-mini {{item.src}}\"><md-tooltip md-direction=\"{{item.direction || \'left\'}}\">{{item.label}}</md-tooltip><md-icon class=\"material-icons\">{{item.src}}</md-icon></md-button></md-fab-actions>");
$templateCache.put("app/components/pager/pager.html","<div ng-show=\"$ctrl.previous\" class=\"previous\"><a ng-click=\"$ctrl.changePage(\'previous\')\">previous</a></div><div ng-show=\"$ctrl.next\" class=\"next\"><a ng-click=\"$ctrl.changePage(\'next\')\">next</a></div>");
$templateCache.put("app/components/searchbar/searchbar.html","<div class=\"searchy\"><div id=\"search\"><tags-input ng-model=\"$ctrl.filter.tag.tags\" template=\"tag-temp.html\" title=\"Tags\" placeholder=\"search by tag\" replace-spaces-with-dashes=\"false\" add-on-enter=\"false\" on-tag-removed=\"$ctrl.updateTags($tag)\" on-tag-added=\"$ctrl.updateTags($tag)\"><auto-complete source=\"$ctrl.findTags($query)\" min-length=\"1\" template=\"result-temp.html\"></auto-complete></tags-input><script type=\"text/ng-template\" id=\"tag-temp.html\"><span><a ng-bind=\"$getDisplayText()\" ui-sref=\"tagged({ tag : \'{{ data[\'text\'] | taglink }}\' })\"></a></span><a ng-click=\"$removeTag()\" ng-bind=\"::$$removeTagSymbol\" class=\"remove-button\"></a></script><script type=\"text/ng-template\" id=\"result-temp.html\"><span ng-bind-html=\"$highlight($getDisplayText())\" class=\"text\">{{data.text}}</span><span class=\"number\">({{data._sort.size}})</span></script></div></div>");
$templateCache.put("app/components/slides/slides.html","<div class=\"slides\"><md-grid-list md-cols=\"{{$ctrl.cols.sm}}\" md-cols-sm=\"{{$ctrl.cols.sm}}\" md-cols-md=\"{{$ctrl.cols.md}}\" md-cols-lg=\"{{$ctrl.cols.lg}}\" md-cols-gt-lg=\"{{$ctrl.cols.gt}}\" md-row-height=\"1:1\" md-gutter=\"5px\" md-on-layout=\"$ctrl.broadcastService.send(\'slides.layout\')\"><md-grid-tile ng-repeat=\"(n, image) in $ctrl.view.images\" md-colspan=\"{{$ctrl.aspect(image,0)}}\" md-rowspan=\"{{$ctrl.aspect(image,1)}}\" ng-init=\"ratio= $ctrl.ratio(image)\" ng-class=\"{vertical: (ratio &gt; 1), horizontal: (ratio&lt;1), square: (ratio ==1), private: image.private, selected: (image.selected == true), deleting: image.delete}\" ng-attr-id=\"{{image._id}}\" on-long-press=\"$ctrl.broadcastService.send(\'slide.select\',image)\"><div class=\"img-container\"><a ng-href=\"{{$ctrl.getLink(image._id)}}\" ng-click=\"$ctrl.tryLink($event, image)\"><img ng-src=\"{{image.derivative[$ctrl.derivative].uri}}\" class=\"img-responsive\"></a></div><div ng-if=\"$ctrl.user.role==\'admin\'||$ctrl.user.role==\'download\'\" class=\"edit-actions\"><md-button ng-click=\"$ctrl.broadcastService.send(\'slide.select\',image)\" class=\"select-slide\"><md-icon class=\"material-icons\">done</md-icon></md-button></div></md-grid-tile></md-grid-list></div>");
$templateCache.put("app/components/slideshow/slideshow.html","<div ui-view=\"\" ng-swipe-left=\"$ctrl.showChange(\'slideright\')\" ng-swipe-right=\"$ctrl.showChange(\'slideleft\')\" ng-swipe-up=\"$ctrl.showChange(\'slideup\')\" ng-swipe-down=\"$ctrl.showChange(\'slidedown\')\" class=\"slideshow close-slide\"></div><slideshow-menu></slideshow-menu>");
$templateCache.put("app/components/admin/delete/deleteDialog.html","<div class=\"action-container\"><p>You\'re about to delete all of the following files FOREVER:</p><md-content layout=\"row\" class=\"md-padding\"><md-card ng-repeat=\"item in ctrl.selectedImages\" flex-xs=\"50\" flex-sm=\"33\" flex-md=\"25\" flex-lg=\"16.6\" flex-xl=\"10\" layout=\"column\"><md-card-title><md-card-title-text><span class=\"md-subtitle\">{{item.filename}}</span></md-card-title-text></md-card-title><md-card-content layout=\"row\"><div class=\"md-media-sm card-media\"><img ng-src=\"{{item.derivative[0].uri}}\" class=\"thumb\"></div></md-card-content></md-card></md-content><p>{{ ctrl.additional }}</p><p>You cannot undo this operation. Are you super duper sure you want to continue?</p><md-button ng-click=\"ctrl.removeAll()\" class=\"md-raised md-primary\">I\'m sure, do it already!</md-button><md-button ng-click=\"ctrl.$mdDialog.hide()\" class=\"md-raised\">Don\'t do it!</md-button></div>");
$templateCache.put("app/components/admin/dropzone/dropzone.html","<div ng-class=\"{processing: $ctrl.processing.length,rejected: $ctrl.rejected.length, queued: $ctrl.queued.length, uploading: $ctrl.uploading.length}\" class=\"upload-container\"><upload-info ng-class=\"{hidepreviews: !$ctrl.showpreviews}\"></upload-info><upload-info-message><div class=\"stats\"><span ng-show=\"$ctrl.processing.length\" class=\"datum processing\">{{$ctrl.processing.length}} processing</span><span ng-show=\"$ctrl.rejected.length\" class=\"datum rejected\">{{$ctrl.rejected.length}} rejected</span><span ng-show=\"$ctrl.queued.length\" class=\"datum queued\">{{$ctrl.queued.length}} queued</span><span ng-show=\"$ctrl.uploading.length\" class=\"datum uploading\">{{$ctrl.uploading.length}} uploading</span><span class=\"datum progress\">{{$ctrl.total | number:0}}% Uploaded</span><span ng-show=\"$ctrl.inprocess\" class=\"datum inprocess\">Processing: {{$ctrl.inprocess.filename}} {{$ctrl.inprocess.percent | number:0}}%</span></div><div class=\"config\"><span ng-click=\"$ctrl.showpreviews = !$ctrl.showpreviews\" class=\"action showpreviews\"><span ng-show=\"$ctrl.showpreviews\">hide previews</span><span ng-show=\"!$ctrl.showpreviews\">show previews</span></span><span class=\"action selectoncomplete\"><label>select on complete</label> <input type=\"checkbox\" ng-model=\"$ctrl.selectoncomplete\"></span></div></upload-info-message></div>");
$templateCache.put("app/components/admin/select/select.html","<actions ng-if=\"$ctrl.selectService.selected.length &gt; 0\"><select-actions></select-actions><md-toolbar><menu-actions menuname=\"menuSelectAction\"></menu-actions></md-toolbar><select-dom-control></select-dom-control></actions>");
$templateCache.put("app/components/admin/tag/tagDialog.html","<div class=\"action-container\"><md-chips ng-model=\"ctrl.selectedTags\" md-transform-chip=\"ctrl.prepareTag($chip)\" md-autocomplete-snap=\"\"><md-autocomplete md-selected-item=\"ctrl.selectedItem\" md-search-text=\"ctrl.searchText\" md-items=\"item in ctrl.findTags(ctrl.searchText)\" md-item-text=\"item.text\" md-min-length=\"1\" md-autofocus=\"true\" placeholder=\"Search or Add Tags\"><md-item-template><span md-highlight-text=\"ctrl.searchText\">{{item.text}} ({{item._images.length}})</span></md-item-template></md-autocomplete><md-chip-template><strong>{{$chip.text}}</strong><span>&nbsp;&#40;{{$chip._images.length}}&#41;&nbsp;</span></md-chip-template></md-chips><md-button ng-click=\"ctrl.add()\" class=\"md-raised md-primary\">Add Tags to Selected Images</md-button><md-button ng-click=\"ctrl.clearSelectedTags()\" class=\"md-raised\">Clear Searched Tags</md-button><md-chips ng-model=\"ctrl.tagsInView\" md-transform-chip=\"ctrl.prepareTag($chip)\" md-removeable=\"true\" md-on-remove=\"ctrl.remove($chip)\" class=\"tagsInView\"><md-chip-template><span><strong>{{$chip.text}}</strong><em>&nbsp; ({{$chip._images.length}})</em></span></md-chip-template></md-chips><md-button ng-click=\"ctrl.$mdDialog.hide()\" class=\"md-raised\">Close</md-button><md-button ng-click=\"ctrl.selectService.none(); ctrl.$mdDialog.hide()\" class=\"md-raised\">Close &amp; Deselect</md-button></div>");
$templateCache.put("app/components/filter/dateRange/dateRange.html","<div class=\"from\"><span>Date From</span><md-datepicker ng-model=\"$ctrl.from\" md-min-date=\"$ctrl.minDate\" md-max-date=\"$ctrl.maxFrom\" ng-change=\"$ctrl.setDate()\"></md-datepicker></div><div class=\"to\"><span>Date To</span><md-datepicker ng-model=\"$ctrl.to\" md-min-date=\"$ctrl.minTo\" md-max-date=\"$ctrl.maxDate\" ng-change=\"$ctrl.setDate()\"></md-datepicker></div>");
$templateCache.put("app/components/filter/uploadDate/uploadDate.html","<div class=\"up\"><md-chips ng-model=\"$ctrl.dates\" readonly=\"true\"><md-chip-template ng-click=\"$ctrl.addDate($chip.date)\"><span>{{$chip.date}}</span></md-chip-template></md-chips></div>");
$templateCache.put("app/components/slideshow/slide/slide.html","<div class=\"slide-wrapper\"><slide-action slide=\"$ctrl.slide\" on-update=\"$ctrl.updateSlide(prop, value)\"></slide-action><video ng-if=\"$ctrl.type==\'video\'\" controls=\"\" preload=\"auto\" class=\"{{$ctrl.layclss}}\"><source ng-src=\"{{$ctrl.src}}\" type=\"video/mp4\"></video><img ng-if=\"$ctrl.type==\'image\'\" ng-src=\"{{$ctrl.src}}\" title=\"{{$ctrl.label}}\" class=\"{{$ctrl.layclss}}\"><div class=\"loading-spinner\"></div></div><slide-info slide=\"$ctrl.slide\" ng-if=\"$ctrl.slideshow.user.role==\'admin\'\"></slide-info><menu-actions menuname=\"menuSlideAction\" context=\"{ slide: $ctrl.slide }\"></menu-actions>");
$templateCache.put("app/components/slideshow/slide/slideInfo.html","<div ng-class=\"{ display: $ctrl.showSlideInfo }\" class=\"info-container\"><div ng-if=\"$ctrl.slide.name\" class=\"name\"><label>name</label><span>{{$ctrl.slide.name}}</span></div><div ng-if=\"$ctrl.slide.description\" class=\"description\"><label>description</label><span>{{$ctrl.slide.description}}</span></div><div ng-if=\"$ctrl.slide.filename\" class=\"filename\"><label>filename</label><span>{{$ctrl.slide.filename}}</span></div><div ng-if=\"$ctrl.slide.createDate\" class=\"createDate\"><label>created at</label><span>{{$ctrl.slide.createDate | date:\'medium\'}}</span></div><div ng-if=\"$ctrl.slide.uploadDate\" class=\"uploadDate\"><label>uploaded at</label><span>{{$ctrl.slide.uploadDate | date:\'medium\'}}</span></div><div ng-if=\"$ctrl.slide.tags.length &gt; 0\" class=\"tags\"><label>tags</label><md-chips ng-model=\"$ctrl.slide.tags\" md-removeable=\"true\" md-on-remove=\"$ctrl.remove($chip)\"><md-chip-template><label>{{$chip._images.length}} count</label><span>{{$chip.text}}</span></md-chip-template></md-chips></div><div ng-if=\"$ctrl.slide.exif.length &gt; 0\" class=\"exif\"><label>EXIF data</label><md-chips ng-model=\"$ctrl.slide.exif\" readonly=\"true\"><md-chip-template><label>{{$chip.name}}</label><span>{{$chip.value}}</span></md-chip-template></md-chips></div></div>");}]);